import { ICONS_NAME } from './store'
import { Color } from '@/utils'

const IconV2 = ({ name, color, size }) => {
    const colorIcon = color || 'currentColor'
    switch (name) {
        case ICONS_NAME.chevronRight:
            return (
                <svg
                    width={size || 8}
                    height={size || 8}
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.37079 5.9458L1.71079 0.295798C1.61783 0.20207 1.50723 0.127676 1.38537 0.0769072C1.26351 0.0261385 1.1328 0 1.00079 0C0.868781 0 0.738075 0.0261385 0.616216 0.0769072C0.494356 0.127676 0.383755 0.20207 0.290792 0.295798C0.104542 0.483161 0 0.736612 0 1.0008C0 1.26498 0.104542 1.51844 0.290792 1.7058L5.24079 6.7058L0.290792 11.6558C0.104542 11.8432 0 12.0966 0 12.3608C0 12.625 0.104542 12.8784 0.290792 13.0658C0.383407 13.1603 0.493852 13.2355 0.615727 13.287C0.737603 13.3384 0.868485 13.3652 1.00079 13.3658C1.1331 13.3652 1.26398 13.3384 1.38586 13.287C1.50773 13.2355 1.61818 13.1603 1.71079 13.0658L7.37079 7.4158C7.4723 7.32216 7.55331 7.2085 7.60871 7.08201C7.66412 6.95551 7.69273 6.8189 7.69273 6.6808C7.69273 6.5427 7.66412 6.40609 7.60871 6.27959C7.55331 6.15309 7.4723 6.03944 7.37079 5.9458Z"
                        fill={colorIcon}
                    />
                </svg>
            )
        case ICONS_NAME.chevronLeft:
            return (
                <svg
                    width={size || 8}
                    height={size || 8}
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.32159 5.9458L5.98159 0.295798C6.07455 0.20207 6.18515 0.127676 6.30701 0.0769072C6.42887 0.0261385 6.55958 0 6.69159 0C6.8236 0 6.95431 0.0261385 7.07617 0.0769072C7.19803 0.127676 7.30863 0.20207 7.40159 0.295798C7.58784 0.483161 7.69238 0.736612 7.69238 1.0008C7.69238 1.26498 7.58784 1.51844 7.40159 1.7058L2.45159 6.7058L7.40159 11.6558C7.58784 11.8432 7.69238 12.0966 7.69238 12.3608C7.69238 12.625 7.58784 12.8784 7.40159 13.0658C7.30898 13.1603 7.19853 13.2355 7.07666 13.287C6.95478 13.3384 6.8239 13.3652 6.69159 13.3658C6.55928 13.3652 6.4284 13.3384 6.30653 13.287C6.18465 13.2355 6.0742 13.1603 5.98159 13.0658L0.32159 7.4158C0.220086 7.32216 0.139077 7.2085 0.0836697 7.08201C0.0282621 6.95551 -0.000342369 6.8189 -0.000342369 6.6808C-0.000342369 6.5427 0.0282621 6.40609 0.0836697 6.27959C0.139077 6.15309 0.220086 6.03944 0.32159 5.9458Z"
                        fill={colorIcon}
                    />
                </svg>
            )
        case ICONS_NAME.delete:
            return (
                <svg
                    width={size || 20}
                    height={size || 20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.0835 4.14175L7.26683 3.05008C7.40016 2.25841 7.50016 1.66675 8.9085 1.66675H11.0918C12.5002 1.66675 12.6085 2.29175 12.7335 3.05841L12.9168 4.14175"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M15.7082 7.6167L15.1665 16.0084C15.0748 17.3167 14.9998 18.3334 12.6748 18.3334H7.32484C4.99984 18.3334 4.92484 17.3167 4.83317 16.0084L4.2915 7.6167"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M8.6084 13.75H11.3834"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.9165 10.4167H12.0832"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.increase:
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="2"
                        height="7.07063"
                        transform="matrix(0.707101 0.707112 -0.707101 0.707112 15.6567 2.92871)"
                        fill="#3F8E6A"
                    />

                    <rect
                        width="2"
                        height="7.26086"
                        transform="matrix(0.707101 0.707112 -0.707101 0.707112 8.13416 10.4431)"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M11.75 3H13.5H17V6.5V8.25M8.25 17H6.5H3V13.5V11.75"
                        stroke="#3F8E6A"
                        strokeWidth="2"
                    />
                </svg>
            )

        case ICONS_NAME.collapse2:
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="2"
                        height="7.07063"
                        transform="matrix(-0.707101 -0.707112 0.707101 -0.707112 13.0713 8.34265)"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M16.978 8.27136L15.228 8.27136L11.728 8.27136L11.728 4.77136L11.728 3.02136"
                        stroke="#3F8E6A"
                        strokeWidth="2"
                    />

                    <rect
                        width="2"
                        height="7.07063"
                        transform="matrix(0.707101 0.707112 -0.707101 0.707112 5.99968 13.0001)"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M2.09294 13.0714L3.84294 13.0713L7.34294 13.0713L7.34294 16.5713L7.34294 18.3213"
                        stroke="#3F8E6A"
                        strokeWidth="2"
                    />
                </svg>
            )

        case ICONS_NAME.drag:
            return (
                <svg
                    width="9"
                    height="15"
                    viewBox="0 0 9 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="3" height="3" fill="#575757" />

                    <rect y="6" width="3" height="3" fill="#575757" />

                    <rect y="12" width="3" height="3" fill="#575757" />

                    <rect x="6" width="3" height="3" fill="#575757" />

                    <rect x="6" y="6" width="3" height="3" fill="#575757" />

                    <rect x="6" y="12" width="3" height="3" fill="#575757" />
                </svg>
            )

        case ICONS_NAME.expandDown:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.63585 10.0256C6.83255 10.23 7.15973 10.23 7.35643 10.0256L11.3776 5.84669C11.6832 5.52903 11.4581 5 11.0173 5L2.975 5C2.53417 5 2.30905 5.52904 2.61471 5.84669L6.63585 10.0256Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.expandUp:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.63585 3.97442C6.83255 3.77001 7.15973 3.77001 7.35643 3.97442L11.3776 8.15331C11.6832 8.47097 11.4581 9 11.0173 9H2.975C2.53417 9 2.30905 8.47096 2.61471 8.15331L6.63585 3.97442Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.roundPlus:
            return (
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="7" cy="7" r="7" fill={Color.textDisabled} />

                    <rect x="6" y="3" width="2" height="8" fill={color} />

                    <rect
                        x="3"
                        y="8"
                        width="2"
                        height="8"
                        transform="rotate(-90 3 8)"
                        fill={color}
                    />
                </svg>
            )

        case ICONS_NAME.roundMinus:
            return (
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="7" cy="7" r="7" fill={color} />

                    <rect
                        x="3"
                        y="8"
                        width="2"
                        height="8"
                        transform="rotate(-90 3 8)"
                        fill="white"
                    />
                </svg>
            )

        case ICONS_NAME.csvGreen:
            return (
                <svg
                    width={size || '20'}
                    height={size || '25'}
                    viewBox={`0 0 ${size || '20'} ${size || '25'}`}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 25H16C18.2091 25 20 23.2091 20 21V8.78586C20 7.7332 19.585 6.72296 18.8451 5.97422L14.1156 1.18836C13.3641 0.427952 12.3395 0 11.2704 0H4C1.79086 0 0 1.79086 0 4V21C0 23.2091 1.79086 25 4 25Z"
                        fill="#09B38E"
                    />

                    <mask
                        id="mask0_4467_1086"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width={size || '20'}
                        height={size || '25'}
                    >
                        <path
                            d="M2 25H18C19.1046 25 20 24.1046 20 23V7.96436C20 7.43803 19.7925 6.93291 19.4226 6.55854L13.5284 0.594179C13.1526 0.213976 12.6403 0 12.1058 0H2C0.89543 0 0 0.89543 0 2V23C0 24.1046 0.895431 25 2 25Z"
                            fill="#09B38E"
                        />
                    </mask>

                    <g mask="url(#mask0_4467_1086)">
                        <path
                            d="M5.753 20.3104C5.26555 20.3104 4.84712 20.2122 4.4977 20.0158C4.14829 19.8193 3.87868 19.5443 3.68888 19.1908C3.50339 18.8328 3.41064 18.4116 3.41064 17.9271C3.41064 17.4426 3.50339 17.0235 3.68888 16.6699C3.87868 16.3164 4.14829 16.0414 4.4977 15.8449C4.84712 15.6485 5.26555 15.5503 5.753 15.5503C6.0679 15.5503 6.35476 15.5961 6.61359 15.6878C6.87241 15.7751 7.09241 15.9039 7.27359 16.0741L6.95653 16.8795C6.7581 16.7223 6.56829 16.611 6.38712 16.5455C6.21025 16.4801 6.00966 16.4473 5.78535 16.4473C5.35829 16.4473 5.03045 16.5761 4.80182 16.8336C4.57751 17.0868 4.46535 17.4513 4.46535 17.9271C4.46535 18.2414 4.51496 18.5098 4.61417 18.7324C4.7177 18.9551 4.86653 19.1253 5.06064 19.2431C5.25908 19.3566 5.50064 19.4134 5.78535 19.4134C6.00966 19.4134 6.21025 19.3807 6.38712 19.3152C6.56829 19.2497 6.7581 19.1384 6.95653 18.9812L7.27359 19.7866C7.09241 19.9525 6.87241 20.0812 6.61359 20.1729C6.35476 20.2646 6.0679 20.3104 5.753 20.3104Z"
                            fill="white"
                        />

                        <path
                            d="M9.51868 20.3104C9.15201 20.3104 8.80907 20.2646 8.48985 20.1729C8.17064 20.0812 7.89887 19.9547 7.67456 19.7932L7.97221 18.9943C8.11887 19.0947 8.27417 19.1799 8.43809 19.2497C8.60201 19.3195 8.77456 19.3741 8.95574 19.4134C9.13691 19.4483 9.32672 19.4658 9.52515 19.4658C9.83574 19.4658 10.0557 19.4178 10.1851 19.3217C10.3189 19.2257 10.3857 19.1035 10.3857 18.9551C10.3857 18.8197 10.3404 18.7172 10.2499 18.6473C10.1636 18.5731 10.004 18.5098 9.77103 18.4574L9.0075 18.3003C8.58907 18.213 8.27632 18.0646 8.06927 17.8551C7.86221 17.6455 7.75868 17.3662 7.75868 17.017C7.75868 16.7201 7.83632 16.4626 7.99162 16.2443C8.14691 16.0261 8.36476 15.8558 8.64515 15.7336C8.92985 15.6114 9.26201 15.5503 9.64162 15.5503C9.96515 15.5503 10.2671 15.5961 10.5475 15.6878C10.8279 15.7795 11.0587 15.9104 11.2399 16.0806L10.9422 16.8271C10.7653 16.683 10.5669 16.5761 10.3469 16.5062C10.1312 16.432 9.88966 16.3949 9.62221 16.3949C9.34181 16.3949 9.12613 16.4451 8.97515 16.5455C8.82848 16.6459 8.75515 16.7834 8.75515 16.958C8.75515 17.089 8.80044 17.1959 8.89103 17.2789C8.98162 17.3574 9.14123 17.4207 9.36985 17.4687L10.1204 17.6193C10.5475 17.7066 10.8646 17.8529 11.0716 18.058C11.2787 18.2632 11.3822 18.536 11.3822 18.8765C11.3822 19.1646 11.3046 19.4156 11.1493 19.6295C10.9983 19.8433 10.7826 20.0114 10.5022 20.1336C10.2261 20.2515 9.89829 20.3104 9.51868 20.3104Z"
                            fill="white"
                        />

                        <path
                            d="M13.5339 20.2384L11.4827 15.6223H12.5698L14.1292 19.3152H13.8121L15.3715 15.6223H16.4198L14.3686 20.2384H13.5339Z"
                            fill="white"
                        />

                        <path
                            d="M14.353 7.14288H19.7607C19.8495 7.14288 19.8942 7.03575 19.8318 6.97259L12.5242 -0.42205C12.4613 -0.485621 12.353 -0.441135 12.353 -0.351759V5.14288C12.353 6.24745 13.2485 7.14288 14.353 7.14288Z"
                            fill="#078F74"
                        />
                    </g>
                </svg>
            )

        case ICONS_NAME.csvGrey:
            return (
                <svg
                    width="20"
                    height="25"
                    viewBox="0 0 20 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 25H16C18.2091 25 20 23.2091 20 21V8.78586C20 7.7332 19.585 6.72296 18.8451 5.97422L14.1156 1.18836C13.3641 0.427952 12.3395 0 11.2704 0H4C1.79086 0 0 1.79086 0 4V21C0 23.2091 1.79086 25 4 25Z"
                        fill="#A9BBCB"
                    />

                    <mask
                        id="mask0_4467_1095"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="25"
                    >
                        <path
                            d="M2 25H18C19.1046 25 20 24.1046 20 23V7.96436C20 7.43803 19.7925 6.93291 19.4226 6.55854L13.5284 0.594179C13.1526 0.213976 12.6403 0 12.1058 0H2C0.89543 0 0 0.89543 0 2V23C0 24.1046 0.895431 25 2 25Z"
                            fill="#A9BBCB"
                        />
                    </mask>

                    <g mask="url(#mask0_4467_1095)">
                        <path
                            d="M5.753 20.3102C5.26555 20.3102 4.84712 20.212 4.4977 20.0155C4.14829 19.8191 3.87868 19.5441 3.68888 19.1905C3.50339 18.8326 3.41064 18.4114 3.41064 17.9268C3.41064 17.4423 3.50339 17.0233 3.68888 16.6697C3.87868 16.3161 4.14829 16.0411 4.4977 15.8447C4.84712 15.6483 5.26555 15.55 5.753 15.55C6.0679 15.55 6.35476 15.5959 6.61359 15.6875C6.87241 15.7749 7.09241 15.9036 7.27359 16.0739L6.95653 16.8792C6.7581 16.7221 6.56829 16.6108 6.38712 16.5453C6.21025 16.4798 6.00966 16.4471 5.78535 16.4471C5.35829 16.4471 5.03045 16.5758 4.80182 16.8334C4.57751 17.0866 4.46535 17.451 4.46535 17.9268C4.46535 18.2411 4.51496 18.5096 4.61417 18.7322C4.7177 18.9548 4.86653 19.125 5.06064 19.2429C5.25908 19.3564 5.50064 19.4131 5.78535 19.4131C6.00966 19.4131 6.21025 19.3804 6.38712 19.3149C6.56829 19.2495 6.7581 19.1381 6.95653 18.981L7.27359 19.7864C7.09241 19.9522 6.87241 20.081 6.61359 20.1727C6.35476 20.2643 6.0679 20.3102 5.753 20.3102Z"
                            fill="white"
                        />

                        <path
                            d="M9.51868 20.3102C9.15201 20.3102 8.80907 20.2643 8.48985 20.1727C8.17064 20.081 7.89887 19.9544 7.67456 19.7929L7.97221 18.9941C8.11887 19.0945 8.27417 19.1796 8.43809 19.2495C8.60201 19.3193 8.77456 19.3739 8.95574 19.4131C9.13691 19.4481 9.32672 19.4655 9.52515 19.4655C9.83574 19.4655 10.0557 19.4175 10.1851 19.3215C10.3189 19.2254 10.3857 19.1032 10.3857 18.9548C10.3857 18.8195 10.3404 18.7169 10.2499 18.6471C10.1636 18.5729 10.004 18.5096 9.77103 18.4572L9.0075 18.3C8.58907 18.2127 8.27632 18.0643 8.06927 17.8548C7.86221 17.6453 7.75868 17.3659 7.75868 17.0167C7.75868 16.7199 7.83632 16.4624 7.99162 16.2441C8.14691 16.0258 8.36476 15.8556 8.64515 15.7334C8.92985 15.6112 9.26201 15.55 9.64162 15.55C9.96515 15.55 10.2671 15.5959 10.5475 15.6875C10.8279 15.7792 11.0587 15.9102 11.2399 16.0804L10.9422 16.8268C10.7653 16.6828 10.5669 16.5758 10.3469 16.506C10.1312 16.4318 9.88966 16.3947 9.62221 16.3947C9.34181 16.3947 9.12613 16.4449 8.97515 16.5453C8.82848 16.6457 8.75515 16.7832 8.75515 16.9578C8.75515 17.0887 8.80044 17.1957 8.89103 17.2786C8.98162 17.3572 9.14123 17.4205 9.36985 17.4685L10.1204 17.6191C10.5475 17.7064 10.8646 17.8526 11.0716 18.0578C11.2787 18.2629 11.3822 18.5358 11.3822 18.8762C11.3822 19.1643 11.3046 19.4153 11.1493 19.6292C10.9983 19.8431 10.7826 20.0112 10.5022 20.1334C10.2261 20.2512 9.89829 20.3102 9.51868 20.3102Z"
                            fill="white"
                        />

                        <path
                            d="M13.5339 20.2381L11.4827 15.6221H12.5698L14.1292 19.3149H13.8121L15.3715 15.6221H16.4198L14.3686 20.2381H13.5339Z"
                            fill="white"
                        />

                        <path
                            d="M14.353 7.14264H19.7607C19.8495 7.14264 19.8942 7.03551 19.8318 6.97234L12.5242 -0.422294C12.4613 -0.485866 12.353 -0.441379 12.353 -0.352003V5.14264C12.353 6.2472 13.2485 7.14264 14.353 7.14264Z"
                            fill="#90A8BB"
                        />
                    </g>
                </svg>
            )

        case ICONS_NAME.csvError:
            return (
                <svg
                    width="21"
                    height="25"
                    viewBox="0 0 21 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.64087 2.83838V8.34076L5.46681 10.9887L9.29276 9.66471L13.9689 11.8713L18.6451 9.2234V7.87532C18.6451 7.35784 18.4445 6.86051 18.0855 6.48781L13.2336 1.45087C12.8566 1.0595 12.3366 0.838379 11.7932 0.838379H3.64087C2.5363 0.838379 1.64087 1.73381 1.64087 2.83838Z"
                        fill="#EE7766"
                    />

                    <mask
                        id="mask0_4467_1104"
                        maskUnits="userSpaceOnUse"
                        x="1"
                        y="0"
                        width="18"
                        height="23"
                    >
                        <path
                            d="M3.64087 22.6446H16.6451C17.7496 22.6446 18.6451 21.7492 18.6451 20.6446V7.87532C18.6451 7.35784 18.4445 6.86051 18.0855 6.48781L13.2336 1.45087C12.8566 1.0595 12.3366 0.838379 11.7932 0.838379H3.64087C2.5363 0.838379 1.64087 1.73381 1.64087 2.83838V20.6446C1.64087 21.7492 2.5363 22.6446 3.64087 22.6446Z"
                            fill="#EE7766"
                        />
                    </mask>

                    <g mask="url(#mask0_4467_1104)">
                        <path
                            d="M14.1436 7.06889H18.41C18.4982 7.06889 18.5432 6.96303 18.482 6.89951L12.3156 0.497917C12.2531 0.433101 12.1436 0.477298 12.1436 0.567293V5.06889C12.1436 6.17345 13.039 7.06889 14.1436 7.06889Z"
                            fill="#C75A4B"
                        />
                    </g>

                    <path
                        d="M6.32039 24.5691L19.047 21.7608C20.1256 21.5228 20.8204 20.4526 20.5988 19.3705L18.5772 9.49689L14.5336 13.0962L9.42928 11.5155L5.95209 13.6363L1.67944 11.8721L2.20975 14.4621L3.96619 23.0407C4.18776 24.1228 5.24177 24.8071 6.32039 24.5691Z"
                        fill="#EE7766"
                    />

                    <mask
                        id="mask1_4467_1104"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="1"
                        width="21"
                        height="24"
                    >
                        <path
                            d="M6.32024 24.5692L19.0468 21.7609C20.1254 21.5229 20.8202 20.4527 20.5987 19.3706L18.0426 6.88646C17.9385 6.3784 17.6419 5.93362 17.2152 5.64593L11.4605 1.76628C11.0143 1.46546 10.4632 1.36156 9.9337 1.47842L0 3.67041L2.18361 14.3353L3.96605 23.0408C4.18761 24.1229 5.24162 24.8072 6.32024 24.5692Z"
                            fill="#C75A4B"
                        />
                    </mask>

                    <g mask="url(#mask1_4467_1104)">
                        <path
                            d="M8.71739 21.1026C8.31201 21.1921 7.94667 21.1841 7.62137 21.0786C7.29606 20.9731 7.02324 20.7852 6.80289 20.5148C6.58536 20.2398 6.43377 19.8932 6.34812 19.4748C6.26247 19.0565 6.26553 18.6777 6.35729 18.3384C6.45263 17.9983 6.62823 17.7115 6.88409 17.4777C7.13995 17.244 7.47057 17.0825 7.87595 16.993C8.13783 16.9352 8.3845 16.9221 8.61595 16.9538C8.84663 16.9817 9.05235 17.0525 9.23311 17.1662L9.1118 17.9197C8.919 17.8204 8.74148 17.7592 8.57923 17.7359C8.42057 17.7118 8.24797 17.7203 8.06142 17.7615C7.70627 17.8399 7.45639 18.0112 7.31178 18.2755C7.16998 18.5353 7.14114 18.8705 7.22525 19.2813C7.2808 19.5526 7.36951 19.7753 7.49137 19.9493C7.61682 20.1225 7.77068 20.2421 7.95295 20.3083C8.13803 20.3698 8.34896 20.3745 8.58573 20.3223C8.77228 20.2811 8.93331 20.216 9.06882 20.127C9.20791 20.0373 9.34609 19.9063 9.48333 19.7342L9.88937 20.3714C9.76802 20.5478 9.60782 20.6994 9.40878 20.826C9.20974 20.9526 8.97927 21.0448 8.71739 21.1026Z"
                            fill="white"
                        />

                        <path
                            d="M11.849 20.4116C11.5441 20.4789 11.2508 20.5022 10.9691 20.4817C10.6875 20.4611 10.4391 20.4017 10.224 20.3034L10.3303 19.5592C10.47 19.6189 10.6142 19.6639 10.7629 19.6941C10.9116 19.7243 11.0647 19.7398 11.2223 19.7405C11.3792 19.7374 11.5401 19.7176 11.7051 19.6812C11.9634 19.6242 12.1379 19.5424 12.2285 19.4357C12.3228 19.3283 12.3568 19.2105 12.3305 19.0823C12.3066 18.9655 12.2508 18.8853 12.1631 18.8416C12.0783 18.7934 11.9343 18.768 11.7314 18.7655L11.0686 18.77C10.7052 18.7714 10.4189 18.7006 10.2096 18.5578C10.0004 18.4149 9.86493 18.1927 9.8032 17.8912C9.75073 17.6349 9.76978 17.3983 9.86034 17.1814C9.95091 16.9645 10.102 16.7775 10.3136 16.6205C10.5287 16.4628 10.7942 16.3491 11.1098 16.2794C11.3789 16.22 11.6381 16.2042 11.8875 16.2319C12.1369 16.2596 12.352 16.3303 12.5327 16.444L12.4172 17.143C12.2446 17.0511 12.0607 16.9952 11.8654 16.9753C11.6729 16.9508 11.4654 16.9631 11.243 17.0122C11.0098 17.0636 10.8393 17.1466 10.7315 17.2609C10.6273 17.3745 10.5906 17.5067 10.6215 17.6574C10.6446 17.7705 10.7012 17.8545 10.7912 17.9095C10.8804 17.9607 11.0243 17.9861 11.223 17.9856L11.8738 17.9778C12.2444 17.9748 12.5339 18.0429 12.7424 18.182C12.9508 18.3212 13.0852 18.5377 13.1453 18.8316C13.1963 19.0804 13.1761 19.3113 13.0847 19.5245C12.997 19.7368 12.8473 19.9215 12.6357 20.0785C12.427 20.2309 12.1647 20.3419 11.849 20.4116Z"
                            fill="white"
                        />

                        <path
                            d="M15.1755 19.6126L12.6537 16.0037L13.5577 15.8042L15.5074 18.7063L15.2437 18.7645L15.8877 15.2901L16.7595 15.0977L15.8696 19.4594L15.1755 19.6126Z"
                            fill="white"
                        />
                    </g>
                </svg>
            )

        case ICONS_NAME.arrowLeft:
            return (
                <svg
                    width={size || 15}
                    height={size || 12}
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M15 6L2 6" stroke="#009B7C" strokeWidth="2" />

                    <path d="M6.5 10.5L2 6L6.5 1.5" stroke="#009B7C" strokeWidth="2" />
                </svg>
            )

        case ICONS_NAME.arrowRight:
            return (
                <svg
                    width={size || 15}
                    height={size || 12}
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 6L13 6" stroke="#009B7C" strokeWidth="2" />

                    <path d="M8.5 1.5L13 6L8.5 10.5" stroke="#009B7C" strokeWidth="2" />
                </svg>
            )

        case ICONS_NAME.downArrow:
            return (
                <svg
                    width={size || 10}
                    height={size || 7}
                    viewBox="0 0 10 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M1 1L5 5L9 1" stroke={colorIcon} strokeWidth="1.5" />
                </svg>
            )

        case ICONS_NAME.home:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 7.73V2.97C16 1.92 15.552 1.5 14.439 1.5H11.611C10.498 1.5 10.05 1.92 10.05 2.97V7.73C10.05 8.78 10.498 9.2 11.611 9.2H14.439C15.552 9.2 16 8.78 16 7.73Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M16 14.93V13.67C16 12.62 15.552 12.2 14.439 12.2H11.611C10.498 12.2 10.05 12.62 10.05 13.67V14.93C10.05 15.98 10.498 16.4 11.611 16.4H14.439C15.552 16.4 16 15.98 16 14.93Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.95 9.97V14.7299C7.95 15.7799 7.502 16.2 6.389 16.2H3.561C2.448 16.2 2 15.7799 2 14.7299V9.97C2 8.92 2.448 8.5 3.561 8.5H6.389C7.502 8.5 7.95 8.92 7.95 9.97Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M8 2.9V4.1C8 5.1 7.54824 5.5 6.42588 5.5H3.57412C2.45176 5.5 2 5.1 2 4.1V2.9C2 1.9 2.45176 1.5 3.57412 1.5H6.42588C7.54824 1.5 8 1.9 8 2.9Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.categories:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.7583 2.16892L14.1879 4.13595C15.4642 4.69903 15.4642 5.62999 14.1879 6.19307L9.7583 8.16012C9.25528 8.38535 8.42943 8.38535 7.92641 8.16012L3.49685 6.19307C2.22053 5.62999 2.22053 4.69903 3.49685 4.13595L7.92641 2.16892C8.42943 1.94369 9.25528 1.94369 9.7583 2.16892Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M2.24304 8.23511C2.24304 8.86576 2.71603 9.59401 3.29413 9.84927L8.39188 12.1166C8.78228 12.2893 9.22524 12.2893 9.60813 12.1166L14.7059 9.84927C15.284 9.59401 15.757 8.86576 15.757 8.23511"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M2.24304 11.989C2.24304 12.6872 2.65597 13.3179 3.29413 13.6032L8.39188 15.8705C8.78228 16.0432 9.22524 16.0432 9.60813 15.8705L14.7059 13.6032C15.344 13.3179 15.757 12.6872 15.757 11.989"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.users:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.0104 5.81012C12.9704 5.80345 12.9237 5.80345 12.8837 5.81012C11.9637 5.77678 11.2304 5.02345 11.2304 4.09012C11.2304 3.13678 11.9971 2.37012 12.9504 2.37012C13.9037 2.37012 14.6704 3.14345 14.6704 4.09012C14.6637 5.02345 13.9304 5.77678 13.0104 5.81012Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M12.3233 10.6636C13.2367 10.8169 14.2433 10.6569 14.95 10.1836C15.89 9.55691 15.89 8.53025 14.95 7.90358C14.2367 7.43022 13.2167 7.27022 12.3033 7.43022"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M4.98935 5.81012C5.02935 5.80345 5.07601 5.80345 5.11601 5.81012C6.03601 5.77678 6.76935 5.02345 6.76935 4.09012C6.76935 3.13678 6.00268 2.37012 5.04935 2.37012C4.09601 2.37012 3.32935 3.14345 3.32935 4.09012C3.33601 5.02345 4.06935 5.77678 4.98935 5.81012Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M5.67664 10.6636C4.7633 10.8169 3.75664 10.6569 3.04997 10.1836C2.10997 9.55691 2.10997 8.53025 3.04997 7.90358C3.7633 7.43022 4.7833 7.27022 5.69664 7.43022"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M9.0117 10.7902C8.9717 10.7835 8.92504 10.7835 8.88504 10.7902C7.96504 10.7569 7.23169 10.0035 7.23169 9.07021C7.23169 8.11688 7.99837 7.35022 8.9517 7.35022C9.90504 7.35022 10.6717 8.12355 10.6717 9.07021C10.665 10.0035 9.9317 10.7635 9.0117 10.7902Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.07213 12.8904C6.13213 13.517 6.13213 14.5436 7.07213 15.1703C8.13879 15.8836 9.88546 15.8836 10.9521 15.1703C11.8921 14.5436 11.8921 13.517 10.9521 12.8904C9.89213 12.1837 8.13879 12.1837 7.07213 12.8904Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.logo:
            return (
                <svg
                    width="54"
                    height="41"
                    viewBox="0 0 54 41"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.408 36.176C0.408 35.5893 0.517333 35.08 0.736 34.648C0.96 34.2107 1.28 33.872 1.696 33.632C2.112 33.392 2.60533 33.272 3.176 33.272C3.74667 33.272 4.24 33.392 4.656 33.632C5.072 33.872 5.392 34.2107 5.616 34.648C5.84533 35.08 5.96 35.5867 5.96 36.168C5.96 36.76 5.84533 37.2747 5.616 37.712C5.392 38.144 5.072 38.4827 4.656 38.728C4.24 38.968 3.74667 39.088 3.176 39.088C2.60533 39.088 2.112 38.968 1.696 38.728C1.28533 38.4827 0.968 38.1413 0.744 37.704C0.52 37.2667 0.408 36.7573 0.408 36.176ZM1.712 36.176C1.712 36.56 1.76533 36.8933 1.872 37.176C1.97867 37.4533 2.14133 37.6667 2.36 37.816C2.57867 37.96 2.85067 38.032 3.176 38.032C3.656 38.032 4.02133 37.8693 4.272 37.544C4.52267 37.2133 4.648 36.7573 4.648 36.176C4.648 35.7867 4.592 35.4533 4.48 35.176C4.37333 34.8987 4.208 34.688 3.984 34.544C3.76533 34.4 3.496 34.328 3.176 34.328C2.68533 34.328 2.31733 34.4907 2.072 34.816C1.832 35.136 1.712 35.5893 1.712 36.176ZM6.86338 39V33.36H7.95938L9.91938 37.76H9.66338L11.6234 33.36H12.7114V39H11.5754V35.168H11.8954L10.1434 39H9.42338L7.66338 35.168H7.99938V39H6.86338ZM13.791 39V33.36H14.719L17.783 37.256H17.567V33.36H18.727V39H17.799L14.743 35.104H14.951V39H13.791ZM19.7891 39V33.36H21.0371V39H19.7891ZM24.0278 39.064C23.5744 39.064 23.1798 39.0053 22.8438 38.888C22.5078 38.7653 22.2064 38.5893 21.9398 38.36L22.1078 38.072C22.3051 38.2267 22.4944 38.3547 22.6758 38.456C22.8571 38.552 23.0544 38.624 23.2678 38.672C23.4864 38.7147 23.7371 38.736 24.0198 38.736C24.5424 38.736 24.9371 38.632 25.2038 38.424C25.4758 38.2107 25.6118 37.928 25.6118 37.576C25.6118 37.2773 25.5158 37.048 25.3238 36.888C25.1371 36.728 24.8144 36.6027 24.3558 36.512L23.5638 36.352C23.0464 36.2453 22.6624 36.0773 22.4118 35.848C22.1611 35.6187 22.0358 35.3013 22.0358 34.896C22.0358 34.576 22.1184 34.296 22.2838 34.056C22.4491 33.816 22.6784 33.6293 22.9718 33.496C23.2651 33.3627 23.6064 33.296 23.9958 33.296C24.3904 33.296 24.7504 33.3573 25.0758 33.48C25.4011 33.6027 25.6811 33.7867 25.9158 34.032L25.7558 34.32C25.4944 34.0693 25.2251 33.8907 24.9478 33.784C24.6704 33.6773 24.3531 33.624 23.9958 33.624C23.5051 33.624 23.1131 33.7387 22.8198 33.968C22.5318 34.1973 22.3878 34.5067 22.3878 34.896C22.3878 35.2107 22.4811 35.456 22.6678 35.632C22.8544 35.8027 23.1558 35.9307 23.5718 36.016L24.3718 36.176C24.9264 36.288 25.3291 36.4507 25.5798 36.664C25.8358 36.872 25.9638 37.1733 25.9638 37.568C25.9638 37.8613 25.8864 38.1227 25.7318 38.352C25.5771 38.576 25.3531 38.752 25.0598 38.88C24.7718 39.0027 24.4278 39.064 24.0278 39.064ZM28.3307 39V33.672H26.2347V33.36H30.7627V33.672H28.6667V39H28.3307ZM31.5694 39V33.36H33.7294C34.3001 33.36 34.7428 33.4933 35.0574 33.76C35.3721 34.0267 35.5294 34.4027 35.5294 34.888C35.5294 35.2027 35.4574 35.472 35.3134 35.696C35.1694 35.9147 34.9721 36.0827 34.7214 36.2C34.4761 36.312 34.1934 36.368 33.8734 36.368L34.0414 36.304H34.1054C34.3188 36.304 34.5081 36.3547 34.6734 36.456C34.8441 36.552 34.9801 36.728 35.0814 36.984L35.8574 39H35.4814L34.7774 37.112C34.6708 36.8187 34.5134 36.632 34.3054 36.552C34.1028 36.4667 33.8388 36.424 33.5134 36.424H31.9054V39H31.5694ZM31.9054 36.112H33.6974C34.1774 36.112 34.5428 36.008 34.7934 35.8C35.0441 35.5867 35.1694 35.2827 35.1694 34.888C35.1694 34.4933 35.0441 34.192 34.7934 33.984C34.5428 33.776 34.1774 33.672 33.6974 33.672H31.9054V36.112ZM36.9582 39V33.36H40.3822V33.672H37.2942V35.984H40.2062V36.296H37.2942V38.688H40.3822V39H36.9582ZM40.9133 39L43.3373 33.36H43.6653L46.1373 39H45.7693L45.0573 37.368L45.2413 37.44H41.7453L41.9693 37.368L41.2733 39H40.9133ZM43.4893 33.808L42.0573 37.176L41.8813 37.128H45.1053L44.9773 37.176L43.5053 33.808H43.4893ZM47.1029 39V33.36H47.3989L49.8309 38.864H49.6069L52.0469 33.36H52.3349V39H52.0229V33.688H52.2149L49.8629 39H49.5829L47.2229 33.68H47.4149V39H47.1029Z"
                        fill="#001A13"
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M33.2261 2.95874C34.3932 2.95874 35.3695 3.27752 36.0459 3.95388C36.9491 4.85745 37.2126 6.29685 36.9326 8.011C36.8645 8.42661 36.7642 8.85829 36.6334 9.30255C36.3562 10.2446 35.941 11.2425 35.3999 12.2621C35.1839 12.6686 34.9507 13.0779 34.6956 13.4887C34.5334 13.7505 34.3611 14.0126 34.1832 14.2744C34.1898 14.0182 34.1933 13.7602 34.1933 13.5002C34.1933 13.2331 34.1894 12.9682 34.1825 12.7053C34.1615 11.9133 34.1087 11.1401 34.0276 10.3893C33.942 9.59337 33.8228 8.82403 33.6749 8.0844C33.5767 7.5947 33.4659 7.11862 33.3429 6.65688C32.9867 5.32478 32.5298 4.11502 31.988 3.06605C32.4194 2.99544 32.8339 2.95874 33.2261 2.95874Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.5 0C27.7773 0 28.9811 0.831557 29.9951 2.24125C30.2408 2.58276 30.4747 2.95851 30.6963 3.36433C31.1657 4.22525 31.5775 5.22284 31.9155 6.32494C32.0521 6.7706 32.1783 7.23165 32.2898 7.70947C32.359 8.00553 32.4216 8.30858 32.4803 8.61548C32.3031 8.42882 32.1235 8.24322 31.9399 8.06006C31.7564 7.8762 31.5715 7.69619 31.3856 7.51967C30.8039 6.96704 30.2132 6.45217 29.6179 5.97295C28.9965 5.47241 28.3701 5.01416 27.7441 4.59681C27.3285 4.31962 26.9136 4.06131 26.5 3.82223C25.3071 3.13188 24.1291 2.59988 23.0046 2.24125C24.0187 0.831208 25.2228 0 26.5 0Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.9538 3.95388C17.6301 3.27752 18.606 2.95874 19.7739 2.95874C20.166 2.95874 20.5802 2.99544 21.0116 3.0657C21.4272 3.13386 21.8589 3.23348 22.3035 3.36421C23.243 3.64104 24.2389 4.05735 25.2557 4.59669C25.6678 4.8155 26.0834 5.05563 26.5001 5.31429C26.7577 5.47438 27.0153 5.64146 27.2733 5.81658C27.0174 5.80994 26.7594 5.80645 26.5001 5.80645C26.2404 5.80645 25.9824 5.80994 25.7265 5.81658C24.9243 5.83721 24.1421 5.89069 23.3822 5.97283C22.5887 6.05847 21.8218 6.17731 21.0843 6.32482C20.5946 6.42304 20.1182 6.53384 19.6568 6.65688C18.325 7.01271 17.1159 7.46921 16.0673 8.011C15.7873 6.2965 16.0505 4.8571 16.9538 3.95388Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13 13.5001C13 12.2225 13.8316 11.0187 15.2416 10.0043C15.5835 9.75858 15.9599 9.52439 16.3664 9.30243C17.227 8.83335 18.2235 8.42229 19.3249 8.08428C19.771 7.94761 20.2316 7.82143 20.7095 7.70958C21.0052 7.64072 21.3082 7.5785 21.6144 7.51978C21.4288 7.69629 21.2436 7.87631 21.0601 8.06017C20.8762 8.24367 20.6962 8.42858 20.5197 8.61454C19.967 9.19617 19.4522 9.78725 18.9726 10.3825C18.4724 11.004 18.0142 11.63 17.5972 12.2561C17.32 12.6717 17.0617 13.0866 16.8226 13.5001C16.1326 14.693 15.6002 15.871 15.2416 16.9955C13.8316 15.9815 13 14.7773 13 13.5001Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.9539 23.0457C16.0507 22.1425 15.7871 20.703 16.0675 18.9885C16.1353 18.5729 16.2356 18.1413 16.3663 17.697C16.6432 16.7567 17.0574 15.7612 17.5971 14.7437C17.8155 14.3316 18.0522 13.9164 18.3112 13.4997C18.4713 13.2421 18.6415 12.9838 18.8163 12.7258C18.81 12.982 18.8065 13.24 18.8065 13.5001C18.8065 13.7598 18.81 14.0177 18.8163 14.2739C18.8372 15.0754 18.8907 15.8577 18.9729 16.6176C19.0585 17.4107 19.1773 18.1776 19.3248 18.9151C19.4227 19.4049 19.5335 19.8809 19.6569 20.3423C20.0134 21.6779 20.4717 22.8901 21.0152 23.9408C19.2465 24.2292 17.8362 23.9276 16.9539 23.0457Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.4998 26.9999C25.2181 26.9999 24.01 26.1631 22.9939 24.7443C22.7538 24.4091 22.5248 24.0411 22.3078 23.644C21.8363 22.781 21.4231 21.7806 21.084 20.6746C20.947 20.2286 20.8208 19.7676 20.7093 19.2901C20.6405 18.9944 20.5779 18.6917 20.5195 18.3855C20.696 18.5715 20.8761 18.7564 21.0599 18.9399C21.2431 19.1234 21.4287 19.303 21.6153 19.4803C22.1931 20.0287 22.7863 20.5443 23.3889 21.0277C24.0097 21.5254 24.6403 21.9879 25.2757 22.4091C25.6826 22.6789 26.0909 22.9334 26.4998 23.1693C27.618 23.8139 28.739 24.3287 29.833 24.6933C29.8914 24.7129 29.9473 24.7258 30.0054 24.7443C28.9892 26.1631 27.7816 26.9999 26.4998 26.9999Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.0458 23.0456C35.1639 23.9275 33.7531 24.2291 31.9848 23.9408C31.5724 23.8733 31.141 23.7754 30.6915 23.6436C30.5402 23.5993 30.3867 23.5514 30.2312 23.4996C29.4087 23.2256 28.5681 22.8575 27.7243 22.4087C27.3164 22.192 26.9077 21.9568 26.5002 21.7026C26.2345 21.537 25.9696 21.3629 25.7053 21.1822C25.9682 21.1892 26.2331 21.193 26.5002 21.193C26.7669 21.193 27.0318 21.1892 27.295 21.1822C28.0871 21.1612 28.8599 21.1084 29.6111 21.0273C30.4066 20.9417 31.176 20.8225 31.9156 20.6746C32.4053 20.5768 32.8814 20.466 33.3428 20.3426C34.678 19.9857 35.8902 19.5278 36.941 18.9846C37.2293 20.7529 36.9277 22.1637 36.0458 23.0456Z"
                        fill={Color.primary}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M37.7466 17.0043C37.4111 17.2448 37.042 17.4744 36.6442 17.6918C35.7812 18.1634 34.7808 18.5765 33.6752 18.9156C33.2288 19.0526 32.7681 19.1788 32.2903 19.2903C31.9946 19.3595 31.6916 19.4217 31.385 19.4804C31.5713 19.3032 31.7569 19.1236 31.9404 18.9401C32.1239 18.7565 32.304 18.5716 32.4801 18.386C33.0327 17.8047 33.548 17.2137 34.0272 16.6184C34.5312 15.992 34.9926 15.3608 35.4124 14.7302C35.6844 14.3216 35.9381 13.9137 36.1734 13.5071C36.8655 12.3117 37.3992 11.1313 37.7585 10.0044C39.1686 11.0184 40.0001 12.2226 40.0001 13.5002C40.0001 14.7812 39.164 15.9885 37.7466 17.0043Z"
                        fill={Color.primary}
                    />
                </svg>
            )

        case ICONS_NAME.logout:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="1" y="1" width="16" height="16" rx="4" stroke={color} />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 10.6333C7.11225 10.6333 5.5 10.9191 5.5 12.0643C5.5 13.2095 7.10243 13.5057 9 13.5057C10.8882 13.5057 12.5 13.2194 12.5 12.0747C12.5 10.9299 10.8981 10.6333 9 10.6333Z"
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.00016 9.00013C10.2392 9.00013 11.2435 7.99413 11.2435 6.75299C11.2435 5.51186 10.2392 4.50586 9.00016 4.50586C7.76163 4.50586 6.75734 5.51186 6.75734 6.75299C6.75293 7.98971 7.74985 8.9957 8.98494 9.00013H9.00016Z"
                        stroke={color}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.password:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.33331 12.8334H4.66665C2.79998 12.8334 2.33331 12.25 2.33331 9.91671V8.75004C2.33331 6.41671 2.79998 5.83337 4.66665 5.83337H9.33331C11.2 5.83337 11.6666 6.41671 11.6666 8.75004V9.91671C11.6666 12.25 11.2 12.8334 9.33331 12.8334Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M4.66669 5.83329V4.66663C4.66669 2.73579 5.05558 1.16663 7.00002 1.16663C8.54746 1.16663 9.18268 2.07884 9.309 3.49996"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.00002 10.7917C7.80543 10.7917 8.45835 10.1387 8.45835 9.33333C8.45835 8.52793 7.80543 7.875 7.00002 7.875C6.19461 7.875 5.54169 8.52793 5.54169 9.33333C5.54169 10.1387 6.19461 10.7917 7.00002 10.7917Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.reactivate:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.0481 11.3141H8.71503"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M9.88165 12.4739V10.1545"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.23302 6.30985C7.17469 6.30405 7.1047 6.30405 7.04054 6.30985C5.65238 6.26346 4.55001 5.13277 4.55001 3.74114C4.54418 2.32052 5.70487 1.16663 7.13386 1.16663C8.56285 1.16663 9.72354 2.32052 9.72354 3.74114C9.72354 5.13277 8.61535 6.26346 7.23302 6.30985Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.2474 12.6535C6.18587 12.6535 5.13019 12.3867 4.32528 11.8533C2.91379 10.9139 2.91379 9.38315 4.32528 8.4496C5.92925 7.38269 8.55974 7.38269 10.1637 8.4496"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.revoke:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.0481 11.3141H8.71503"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.23302 6.30985C7.17469 6.30405 7.1047 6.30405 7.04054 6.30985C5.65238 6.26346 4.55001 5.13277 4.55001 3.74114C4.54418 2.32052 5.70487 1.16663 7.13386 1.16663C8.56285 1.16663 9.72354 2.32052 9.72354 3.74114C9.72354 5.13277 8.61535 6.26346 7.23302 6.30985Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.2474 12.6535C6.18587 12.6535 5.13019 12.3867 4.32528 11.8533C2.91379 10.9139 2.91379 9.38315 4.32528 8.4496C5.92925 7.38269 8.55974 7.38269 10.1637 8.4496"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.info:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.00002 12.8333C10.2217 12.8333 12.8334 10.2216 12.8334 6.99996C12.8334 3.7783 10.2217 1.16663 7.00002 1.16663C3.77836 1.16663 1.16669 3.7783 1.16669 6.99996C1.16669 10.2216 3.77836 12.8333 7.00002 12.8333Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.75 4.66663C7.75 4.25241 7.41421 3.91663 7 3.91663C6.58579 3.91663 6.25 4.25241 6.25 4.66663H7.75ZM6.25 8.16663C6.25 8.58084 6.58579 8.91663 7 8.91663C7.41421 8.91663 7.75 8.58084 7.75 8.16663H6.25ZM6.25 4.66663V8.16663H7.75V4.66663H6.25Z"
                        fill={colorIcon}
                    />

                    <path
                        d="M7.75 10.0264C7.75 9.61215 7.41421 9.27637 7 9.27637C6.58579 9.27637 6.25 9.61215 6.25 10.0264L7.75 10.0264ZM6.25 10.0614C6.25 10.4756 6.58579 10.8114 7 10.8114C7.41421 10.8114 7.75 10.4756 7.75 10.0614L6.25 10.0614ZM6.25 10.0264L6.25 10.0614L7.75 10.0614L7.75 10.0264L6.25 10.0264Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.modify:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.41643 1.88013H5.37945C2.78699 1.88013 1.75 2.91711 1.75 5.50958V8.62053C1.75 11.213 2.78699 12.25 5.37945 12.25H8.4904C11.0829 12.25 12.1199 11.213 12.1199 8.62053V7.58355"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M9.02953 2.40912L4.94381 6.49484C4.78826 6.65039 4.63271 6.9563 4.6016 7.17925L4.37865 8.73991C4.29569 9.30507 4.69493 9.69912 5.26009 9.62135L6.82075 9.3984C7.03852 9.36729 7.34443 9.21174 7.50516 9.05619L11.5909 4.97048C12.296 4.26533 12.6279 3.44611 11.5909 2.40912C10.5539 1.37214 9.73468 1.70397 9.02953 2.40912Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M8.44379 2.99512C8.79118 4.23431 9.76076 5.2039 11.0051 5.55647"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.paginationRight:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M5 2L10 7L5 12" stroke={colorIcon} strokeWidth="2" />
                </svg>
            )

        case ICONS_NAME.alert:
            return (
                <svg
                    width={size || '20'}
                    height={size || '20'}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.52699 2.85092L1.23087 15.3485C1.08044 15.6158 1.00085 15.9188 1.00001 16.2275C0.999164 16.5361 1.0771 16.8396 1.22607 17.1078C1.37504 17.3759 1.58984 17.5994 1.84911 17.7559C2.10838 17.9125 2.40308 17.9966 2.70388 18H17.2961C17.5969 17.9966 17.8916 17.9125 18.1509 17.7559C18.4102 17.5994 18.625 17.3759 18.7739 17.1078C18.9229 16.8396 19.0008 16.5361 19 16.2275C18.9992 15.9188 18.9196 15.6158 18.7691 15.3485L11.473 2.85092C11.3194 2.59116 11.1032 2.3764 10.8452 2.22735C10.5872 2.0783 10.2961 2 10 2C9.7039 2 9.41281 2.0783 9.15479 2.22735C8.89678 2.3764 8.68056 2.59116 8.52699 2.85092V2.85092Z"
                        stroke={color || Color.redActive}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M10 7.39404V11.8133"
                        stroke={color || Color.redActive}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M10 14.4642V14.9062"
                        stroke={color || Color.redActive}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.items:
            return (
                <svg
                    width={size || '20'}
                    height={size || '20'}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.051 10.002H2.87101C2.25101 10.002 1.78101 10.5518 1.88101 11.1617L2.72101 16.3007C3.00101 18.0204 3.75101 20 7.08101 20H12.691C16.061 20 16.661 18.3103 17.021 16.4207L18.031 11.1917C18.151 10.5718 17.681 10.002 17.051 10.002ZM8.61097 16.4507C8.61097 16.8406 8.30097 17.1506 7.92101 17.1506C7.53101 17.1506 7.22101 16.8406 7.22101 16.4507V13.1513C7.22101 12.7714 7.53101 12.4515 7.92101 12.4515C8.30097 12.4515 8.61097 12.7714 8.61097 13.1513V16.4507ZM12.891 16.4507C12.891 16.8406 12.581 17.1506 12.191 17.1506C11.811 17.1506 11.491 16.8406 11.491 16.4507V13.1513C11.491 12.7714 11.811 12.4515 12.191 12.4515C12.581 12.4515 12.891 12.7714 12.891 13.1513V16.4507Z"
                        fill={colorIcon}
                    />

                    <path
                        opacity="0.4"
                        d="M17.24 3.5818H16.84L13.46 0.20246C13.19 -0.0674868 12.75 -0.0674868 12.47 0.20246C12.2 0.472408 12.2 0.912322 12.47 1.19227L14.86 3.5818H5.14L7.53 1.19227C7.8 0.92232 7.8 0.482406 7.53 0.20246C7.26 -0.0674868 6.82 -0.0674868 6.54 0.20246L3.17 3.5818H2.77C1.87 3.5818 0 3.5818 0 6.1413C0 7.11111 0.2 7.75099 0.62 8.17092C0.86 8.42087 1.15 8.55084 1.46 8.62083C1.75 8.69081 2.06 8.70081 2.36 8.70081H17.64C17.95 8.70081 18.24 8.68082 18.52 8.62083C19.36 8.42087 20 7.82097 20 6.1413C20 3.5818 18.13 3.5818 17.24 3.5818Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.stores:
            return (
                <svg
                    width={size || '20'}
                    height={size || '20'}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.4"
                        d="M19.0281 9.59754V15.2671C19.0281 17.8795 16.8753 19.9997 14.2227 19.9997H5.82282C3.17023 19.9997 1.0174 17.8795 1.0174 15.2671V9.6638C1.74782 10.4399 2.78579 10.8848 3.91026 10.8848C5.12123 10.8848 6.28414 10.2885 7.01457 9.33252C7.6681 10.2885 8.78295 10.8848 10.0228 10.8848C11.2529 10.8848 12.3486 10.3169 13.0117 9.37038C13.7518 10.3074 14.8955 10.8848 16.0872 10.8848C17.2501 10.8848 18.3073 10.421 19.0281 9.59754Z"
                        fill={colorIcon}
                    />

                    <path
                        d="M12.8969 0H7.13032L6.41911 6.96633C6.36145 7.60996 6.45756 8.21572 6.69783 8.7647C7.25526 10.052 8.56237 10.8849 10.0232 10.8849C11.5033 10.8849 12.7815 10.0709 13.3582 8.77417C13.5312 8.36717 13.6369 7.89391 13.6465 7.41119V7.23135L12.8969 0Z"
                        fill={colorIcon}
                    />

                    <path
                        opacity="0.6"
                        d="M19.9803 6.64451L19.7016 4.02268C19.298 1.16421 17.9813 0 15.1653 0H11.4747L12.1859 7.09884C12.1955 7.19349 12.2052 7.29761 12.2052 7.47744C12.2628 7.96963 12.4166 8.42396 12.6473 8.83096C13.3392 10.0804 14.6848 10.8849 16.0879 10.8849C17.3662 10.8849 18.5195 10.3264 19.2403 9.34207C19.8169 8.58486 20.0764 7.62889 19.9803 6.64451Z"
                        fill={colorIcon}
                    />

                    <path
                        opacity="0.6"
                        d="M4.82401 0C1.99842 0 0.691345 1.16421 0.278078 4.05107L0.0185849 6.65398C-0.0775236 7.66675 0.201191 8.65112 0.806675 9.41779C1.5371 10.3548 2.66157 10.8849 3.91098 10.8849C5.31416 10.8849 6.65968 10.0804 7.34205 8.84989C7.59194 8.42396 7.75532 7.93177 7.80338 7.42065L8.55307 0.00946511H4.82401V0Z"
                        fill={colorIcon}
                    />

                    <path
                        d="M9.39819 14.586C8.17761 14.709 7.255 15.7312 7.255 16.9428V20H12.7812V17.2741C12.7908 15.2959 11.6087 14.3588 9.39819 14.586Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.search:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10.6571 10.8057L12.8571 12.9999"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M6.75431 12.2229C9.85342 12.2229 12.3657 9.71053 12.3657 6.61143C12.3657 3.51232 9.85342 1 6.75431 1C3.6552 1 1.14288 3.51232 1.14288 6.61143C1.14288 9.71053 3.6552 12.2229 6.75431 12.2229Z"
                        stroke={colorIcon}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.cart:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.75911 3.67414C4.75903 3.67032 4.75899 3.66649 4.75899 3.66265V2.89157C4.75899 1.2946 6.21005 0 8.00001 0C9.78998 0 11.241 1.2946 11.241 2.89157V3.66265C11.241 3.66649 11.241 3.67032 11.2409 3.67414C12.3534 3.70393 13.0342 3.81101 13.5539 4.19583C14.274 4.72902 14.4637 5.63153 14.843 7.43654L15.4912 10.5209C16.0247 13.0591 16.2914 14.3281 15.5138 15.1641C14.7362 16 13.2889 16 10.3944 16H5.60558C2.71108 16 1.26383 16 0.486225 15.1641C-0.291376 14.3281 -0.024664 13.0591 0.50876 10.5209L1.15696 7.43655C1.53631 5.63153 1.72598 4.72902 2.44607 4.19583C2.9658 3.811 3.64657 3.70393 4.75911 3.67414ZM6.0554 2.89157C6.0554 1.93339 6.92603 1.15663 8.00001 1.15663C9.074 1.15663 9.94463 1.93339 9.94463 2.89157V3.66265C9.94463 3.66264 9.94463 3.66266 9.94463 3.66265C9.87957 3.66263 9.81344 3.66265 9.74621 3.66265H6.25379C6.18657 3.66265 6.12045 3.66265 6.0554 3.66267C6.0554 3.66266 6.0554 3.66268 6.0554 3.66267V2.89157ZM11.2323 7.42309C11.1735 7.10804 10.8395 6.89521 10.4864 6.94772C10.1332 7.00023 9.89468 7.29819 9.95354 7.61324L10.8178 12.2397C10.8767 12.5548 11.2106 12.7676 11.5638 12.7151C11.9169 12.6626 12.1554 12.3646 12.0966 12.0496L11.2323 7.42309ZM5.51364 6.94772C5.16052 6.89521 4.82655 7.10804 4.76769 7.42309L3.90342 12.0496C3.84457 12.3646 4.08312 12.6626 4.43624 12.7151C4.78936 12.7676 5.12334 12.5548 5.18219 12.2397L6.04646 7.61324C6.10532 7.29819 5.86677 7.00023 5.51364 6.94772Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.detailed:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.27962 14.3287C6.73942 13.6085 5.80159 13.556 5.18636 14.2162C3.85836 15.6342 2.76293 15.1691 2.75543 13.1733L2.75543 4.72511C2.75543 1.70148 3.4607 0.943725 6.29676 0.943724L11.9688 0.943724C14.8049 0.943725 15.5102 1.70149 15.5102 4.72511L15.5102 13.1733C15.5102 15.1691 14.4223 15.6417 13.0868 14.2162C12.4716 13.556 11.5337 13.6085 10.9935 14.3287L10.2357 15.3416C9.62798 16.1444 8.64511 16.1444 8.03738 15.3416L7.27962 14.3287ZM11.3317 8.98697L11.8869 9.54218C12.1045 9.75976 12.1045 10.1199 11.8869 10.3375C11.7743 10.45 11.6318 10.5025 11.4892 10.5025C11.3467 10.5025 11.2041 10.45 11.0916 10.3375L10.5363 9.78227C10.1011 10.0674 9.57594 10.2399 9.01323 10.2399C7.48269 10.2399 6.23724 8.99447 6.23724 7.4639C6.23724 5.93334 7.48269 4.68787 9.01323 4.68786C10.5438 4.68786 11.7893 5.93334 11.7893 7.4639C11.7893 8.02661 11.6168 8.55181 11.3317 8.98697Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.history:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.81701 1.21436H12.1051C14.8365 1.21436 16.4648 2.84186 16.4573 5.57186V11.8569C16.4573 14.5869 14.829 16.2144 12.0976 16.2144H5.81701C3.08565 16.2144 1.45734 14.5869 1.45734 11.8494V5.57186C1.45734 2.84186 3.08565 1.21436 5.81701 1.21436ZM13.4633 12.0894H14.2137C14.5213 12.0894 14.7765 11.8344 14.7765 11.5269C14.7765 11.2194 14.5213 10.9644 14.2137 10.9644H14.0261V10.5894V10.2144V7.96436V5.52686C14.0261 4.38686 13.1031 3.46436 11.9626 3.46436H5.95958C4.81901 3.46436 3.89605 4.38686 3.89605 5.52686V7.96436V10.2144V10.5894V10.9644H3.70846C3.4008 10.9644 3.14568 11.2194 3.14568 11.5269C3.14568 11.8344 3.4008 12.0894 3.70846 12.0894H4.45883H6.58989C6.84502 13.1619 7.813 13.9644 8.96108 13.9644C10.1091 13.9644 11.0771 13.1619 11.3323 12.0894H13.4633ZM11.9626 4.58936H5.95958C5.44182 4.58936 5.02161 5.00936 5.02161 5.52686V6.13436C5.30675 5.99186 5.62191 5.90186 5.95958 5.90186H11.9626C12.3002 5.90186 12.6154 5.99186 12.9005 6.13436V5.52686C12.9005 5.00936 12.4803 4.58936 11.9626 4.58936ZM5.95958 7.02686H11.9626C12.4803 7.02686 12.9005 7.44686 12.9155 7.96436V8.75186C12.9005 8.74436 12.878 8.73686 12.8555 8.72936C12.7655 8.68436 12.6679 8.65436 12.5704 8.62436C12.5491 8.61827 12.529 8.61096 12.5097 8.60391L12.5097 8.6039C12.4813 8.59357 12.4546 8.58381 12.4278 8.57936C12.2777 8.54936 12.1277 8.52686 11.9701 8.52686H5.96708C5.80951 8.52686 5.65943 8.54936 5.50936 8.57936C5.45684 8.59435 5.41182 8.60935 5.36681 8.62435L5.36678 8.62436C5.26924 8.65436 5.17169 8.68436 5.08164 8.72936C5.07039 8.73311 5.06101 8.73686 5.05163 8.74061C5.04225 8.74436 5.03287 8.74811 5.02161 8.75186V7.96436C5.02161 7.44686 5.44182 7.02686 5.95958 7.02686ZM5.95958 9.65186H11.9626C12.4803 9.65186 12.9005 10.0719 12.9005 10.5894V10.9644H10.837C10.5294 10.9644 10.2742 11.2194 10.2742 11.5269C10.2742 12.2469 9.68143 12.8394 8.96108 12.8394C8.24072 12.8394 7.64792 12.2469 7.64792 11.5269C7.64792 11.2194 7.39279 10.9644 7.08514 10.9644H5.02161V10.5894C5.02161 10.0719 5.44182 9.65186 5.95958 9.65186Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.settings:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    =
                    <path
                        d="M16.2819 6.49653C14.6537 6.49653 13.988 5.34385 14.7976 3.93002C15.2654 3.11054 14.9865 2.06593 14.1679 1.59766L12.6117 0.706132C11.901 0.282884 10.9835 0.535032 10.5607 1.24645L10.4618 1.41755C9.65217 2.83138 8.32084 2.83138 7.50225 1.41755L7.4033 1.24645C6.9985 0.535032 6.08096 0.282884 5.37031 0.706132L3.81409 1.59766C2.9955 2.06593 2.71664 3.11955 3.18441 3.93903C4.003 5.34385 3.33733 6.49653 1.70915 6.49653C0.773613 6.49653 0 7.26198 0 8.20753V9.79247C0 10.729 0.764618 11.5035 1.70915 11.5035C3.33733 11.5035 4.003 12.6561 3.18441 14.07C2.71664 14.8895 2.9955 15.9341 3.81409 16.4023L5.37031 17.2939C6.08096 17.7171 6.9985 17.465 7.42129 16.7536L7.52024 16.5825C8.32983 15.1686 9.66117 15.1686 10.4798 16.5825L10.5787 16.7536C11.0015 17.465 11.919 17.7171 12.6297 17.2939L14.1859 16.4023C15.0045 15.9341 15.2834 14.8805 14.8156 14.07C13.997 12.6561 14.6627 11.5035 16.2909 11.5035C17.2264 11.5035 18 10.738 18 9.79247V8.20753C17.991 7.27099 17.2264 6.49653 16.2819 6.49653ZM8.9955 11.9267C7.38531 11.9267 6.07196 10.6119 6.07196 9C6.07196 7.38805 7.38531 6.07328 8.9955 6.07328C10.6057 6.07328 11.919 7.38805 11.919 9C11.919 10.6119 10.6057 11.9267 8.9955 11.9267Z"
                        fill={colorIcon}
                    />
                    =
                </svg>
            )

        case ICONS_NAME.shelf:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.2352 3.94123H14.5351C15.2025 3.94123 16.6047 3.94123 16.6047 5.86086C16.6047 7.12061 16.1248 7.57053 15.495 7.7205C15.285 7.76549 15.0675 7.78049 14.8351 7.78049H3.37732C3.15236 7.78049 2.91991 7.77299 2.70245 7.7205C2.47 7.66801 2.25254 7.57053 2.07258 7.38307C1.75764 7.06812 1.60767 6.58822 1.60767 5.86086C1.60767 3.94123 3.00989 3.94123 3.68476 3.94123H3.9847L6.51171 1.40673C6.72167 1.20427 7.0516 1.20427 7.25406 1.40673C7.45652 1.61669 7.45652 1.94662 7.25406 2.14908L5.46191 3.94123H12.7505L10.9583 2.14908C10.7559 1.93912 10.7559 1.60919 10.9583 1.40673C11.1683 1.20427 11.4982 1.20427 11.7007 1.40673L14.2352 3.94123ZM3.7605 8.75635H14.3934C14.8658 8.75635 15.2182 9.18376 15.1283 9.64867L14.3709 13.5704C14.101 14.9876 13.651 16.2549 11.124 16.2549H6.91738C4.42037 16.2549 3.85798 14.7702 3.64802 13.4804L3.01815 9.62618C2.94316 9.16877 3.29559 8.75635 3.7605 8.75635ZM7.54726 14.1178C7.83218 14.1178 8.06463 13.8853 8.06463 13.5929V11.1184C8.06463 10.8334 7.83218 10.5935 7.54726 10.5935C7.25482 10.5935 7.02236 10.8334 7.02236 11.1184V13.5929C7.02236 13.8853 7.25482 14.1178 7.54726 14.1178ZM10.7491 14.1178C11.0415 14.1178 11.274 13.8853 11.274 13.5929V11.1184C11.274 10.8334 11.0415 10.5935 10.7491 10.5935C10.4642 10.5935 10.2242 10.8334 10.2242 11.1184V13.5929C10.2242 13.8853 10.4642 14.1178 10.7491 14.1178Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.summary:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.1045 0.943726C14.3926 0.943726 15.6667 2.27873 15.6667 4.56623V12.3137C15.6667 14.6387 14.3926 15.9437 12.1045 15.9437H5.89631C3.64445 15.9437 2.33334 14.6387 2.33334 12.3137V4.56623C2.33334 2.27873 3.64445 0.943726 5.89631 0.943726H12.1045ZM6.09631 11.2487C5.87408 11.2262 5.65927 11.3312 5.54075 11.5262C5.42223 11.7137 5.42223 11.9612 5.54075 12.1562C5.65927 12.3437 5.87408 12.4562 6.09631 12.4262H11.9037C12.1993 12.3962 12.4222 12.1405 12.4222 11.8412C12.4222 11.5337 12.1993 11.2787 11.9037 11.2487H6.09631ZM11.9037 7.82798H6.09631C5.77705 7.82798 5.51853 8.09123 5.51853 8.41373C5.51853 8.73623 5.77705 8.99873 6.09631 8.99873H11.9037C12.2222 8.99873 12.4815 8.73623 12.4815 8.41373C12.4815 8.09123 12.2222 7.82798 11.9037 7.82798ZM8.31038 4.43123H6.09631V4.43873C5.77705 4.43873 5.51853 4.70123 5.51853 5.02373C5.51853 5.34623 5.77705 5.60873 6.09631 5.60873H8.31038C8.62964 5.60873 8.8889 5.34623 8.8889 5.01548C8.8889 4.69373 8.62964 4.43123 8.31038 4.43123Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.table:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.71667 1.33643V5.68643H1.40417C1.40417 2.97893 3.01667 1.35143 5.71667 1.33643ZM16.4042 5.68643H12.0917V1.33643C14.7917 1.35143 16.4042 2.97893 16.4042 5.68643ZM12.0917 16.337C14.7692 16.322 16.3742 14.7245 16.4042 12.062H12.0917V16.337ZM5.71667 12.062V16.337C3.03917 16.322 1.43417 14.7245 1.40417 12.062H5.71667ZM1.40417 6.81201H5.71667V10.937H1.40417V6.81201ZM16.4042 6.81201H12.0917V10.937H16.4042V6.81201ZM6.84167 6.81201H10.9667V10.937H6.84167V6.81201ZM10.9667 1.33643H6.84167V5.68643H10.9667V1.33643ZM6.84167 12.062H10.9667V16.337H6.84167V12.062Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.tree:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.2806 1.19373H5.99249C3.26112 1.19373 1.63281 2.82123 1.63281 5.55123V11.8287C1.63281 14.5662 3.26112 16.1937 5.99249 16.1937H12.2731C15.0045 16.1937 16.6328 14.5662 16.6328 11.8362V5.55123C16.6403 2.82123 15.012 1.19373 12.2806 1.19373ZM12.2881 13.3812C11.4402 13.3812 10.7499 12.6912 10.7499 11.8437C10.7499 11.3487 10.99 10.9137 11.3577 10.6287C11.0425 9.80373 10.2546 9.23373 9.36917 9.26373L7.8234 9.27123H7.81589C7.35817 9.27123 6.92295 9.13623 6.55527 8.90373V10.4187C7.12555 10.6437 7.53075 11.1987 7.53075 11.8437C7.53075 12.6912 6.84041 13.3812 5.99249 13.3812C5.14456 13.3812 4.45422 12.6912 4.45422 11.8437C4.45422 11.1912 4.85942 10.6437 5.4297 10.4187V7.15623C4.85942 6.89373 4.45422 6.32373 4.45422 5.65623C4.45422 4.74873 5.19709 4.00623 6.10504 4.00623C7.01299 4.00623 7.75586 4.74873 7.75586 5.65623C7.75586 6.39123 7.26812 7.00623 6.60029 7.22373C6.75036 7.77123 7.24561 8.15373 7.81589 8.15373C7.81589 8.15373 7.81589 8.15373 7.8234 8.15373L9.36917 8.14623C9.37667 8.14623 9.37667 8.14623 9.38417 8.14623C10.7649 8.14623 12.003 9.02373 12.4532 10.3287C13.2261 10.4112 13.8339 11.0562 13.8339 11.8512C13.8264 12.6912 13.136 13.3812 12.2881 13.3812Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.unranged:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.1478 1.44373L5.85967 1.44373C3.12831 1.44373 1.5 3.07123 1.5 5.80123L1.5 12.0787C1.5 14.8162 3.12831 16.4437 5.85967 16.4437L12.1403 16.4437C14.8717 16.4437 16.5 14.8162 16.5 12.0862L16.5 5.80123C16.5075 3.07123 14.8792 1.44373 12.1478 1.44373ZM13.1311 13.3163L11.7429 13.3163C11.4352 13.3163 11.1801 13.0613 11.1801 12.7538C11.1801 12.4463 11.4352 12.1913 11.7429 12.1913L13.1311 12.1913C13.4387 12.1913 13.6939 12.4463 13.6939 12.7538C13.6939 13.0613 13.4387 13.3163 13.1311 13.3163ZM4.87668 13.3163L9.7316 13.3163C10.0468 13.3163 10.2944 13.0613 10.2944 12.7538C10.2944 12.4463 10.0393 12.1913 9.7316 12.1913L4.87668 12.1913C4.56903 12.1913 4.3139 12.4463 4.3139 12.7538C4.3139 13.0613 4.56903 13.3163 4.87668 13.3163ZM13.1313 10.496L8.98176 10.496C8.6741 10.496 8.41898 10.241 8.41898 9.93347C8.41898 9.62597 8.6741 9.37097 8.98176 9.37097L13.1313 9.37097C13.439 9.37097 13.6941 9.62597 13.6941 9.93347C13.6941 10.241 13.439 10.496 13.1313 10.496ZM4.87668 10.496L6.95522 10.496C7.26287 10.496 7.518 10.241 7.518 9.93347C7.518 9.62597 7.26287 9.37097 6.95522 9.37097L4.87668 9.37097C4.56903 9.37097 4.3139 9.62597 4.3139 9.93347C4.3139 10.241 4.56903 10.496 4.87668 10.496Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.clear:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.7087 2.4855C3.88942 2.1843 4.21493 2 4.56619 2H12C12.5523 2 13 2.44772 13 3V11C13 11.5523 12.5523 12 12 12H4.56619C4.21493 12 3.88942 11.8157 3.7087 11.5145L1.3087 7.5145C1.11869 7.19781 1.11869 6.80219 1.3087 6.4855L3.7087 2.4855Z"
                        fill={colorIcon}
                    />

                    <rect
                        x="5.54724"
                        y="5.21436"
                        width="1.01014"
                        height="6.06085"
                        transform="rotate(-45 5.54724 5.21436)"
                        fill={Color.white}
                    />

                    <rect
                        x="6.26154"
                        y="9.49976"
                        width="1.01014"
                        height="6.06085"
                        transform="rotate(-135 6.26154 9.49976)"
                        fill={Color.white}
                    />
                </svg>
            )

        case ICONS_NAME.expand:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.63585 10.0256C6.83255 10.23 7.15973 10.23 7.35643 10.0256L11.3776 5.84669C11.6832 5.52903 11.4581 5 11.0173 5L2.975 5C2.53417 5 2.30905 5.52904 2.61471 5.84669L6.63585 10.0256Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.collapse:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.63586 3.97442C6.83256 3.77001 7.15974 3.77001 7.35644 3.97442L11.3776 8.15331C11.6832 8.47097 11.4581 9 11.0173 9H2.97501C2.53418 9 2.30906 8.47096 2.61472 8.15331L6.63586 3.97442Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.loader:
            return (
                <svg
                    width={size || 30}
                    height={size || 30}
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M25 14C25 20.0751 20.0751 25 14 25C7.92487 25 3 20.0751 3 14C3 7.92487 7.92487 3 14 3"
                        stroke="#3F8E6A"
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                </svg>
            )

        case ICONS_NAME.bay:
            return (
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="1.5" y="5" width="1" height="8" rx="0.5" fill={colorIcon} />

                    <rect x="15.5" y="5" width="1" height="8" rx="0.5" fill={colorIcon} />

                    <rect x="3.5" y="3" width="11" height="12" rx="2" fill={colorIcon} />
                </svg>
            )

        case ICONS_NAME.flip:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.6186 14.5998H11.8094C11.5885 14.5998 11.4094 14.4207 11.4094 14.1998V4.67686C11.4094 4.45594 11.5885 4.27686 11.8094 4.27686C11.973 4.27686 12.1201 4.37644 12.1808 4.5283L15.99 14.0513C16.0721 14.2564 15.9723 14.4892 15.7672 14.5712C15.7199 14.5901 15.6695 14.5998 15.6186 14.5998Z"
                        fill={colorIcon}
                    />

                    <path
                        opacity="0.5"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.40011 14.5998H6.20929C6.43021 14.5998 6.60929 14.4207 6.60929 14.1998V4.67686C6.60929 4.45594 6.43021 4.27686 6.20929 4.27686C6.04573 4.27686 5.89865 4.37644 5.8379 4.5283L2.02872 14.0513C1.94667 14.2564 2.04644 14.4892 2.25155 14.5712C2.2988 14.5901 2.34922 14.5998 2.40011 14.5998Z"
                        fill={colorIcon}
                    />

                    <path
                        d="M8.20939 1.8C8.20939 1.35817 8.56756 1 9.00939 1C9.45122 1 9.80939 1.35817 9.80939 1.8V16.2C9.80939 16.6418 9.45122 17 9.00939 17C8.56756 17 8.20939 16.6418 8.20939 16.2V1.8Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.image:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.0478 2C14.4117 2 16 3.6534 16 6.1216V11.8714C16 11.9771 15.9811 12.0716 15.9755 12.1738C15.972 12.2333 15.9727 12.2928 15.9678 12.3523C15.965 12.3789 15.9573 12.4034 15.9545 12.43C15.9314 12.6498 15.8957 12.8598 15.846 13.0635C15.8334 13.1181 15.8187 13.1706 15.804 13.2238C15.748 13.4212 15.6822 13.6095 15.6031 13.7894C15.58 13.8398 15.5548 13.8881 15.531 13.9378C15.4456 14.1093 15.3532 14.2738 15.2461 14.4264L15.1425 14.5608C15.0312 14.705 14.915 14.8429 14.7834 14.9682C14.7407 15.0088 14.6924 15.0438 14.6476 15.0823C14.5125 15.1985 14.3746 15.3098 14.2227 15.405C14.1681 15.4393 14.1079 15.4645 14.0519 15.4953C13.8972 15.5807 13.7411 15.664 13.571 15.7284C13.501 15.755 13.4233 15.769 13.3505 15.7921C13.1832 15.8439 13.018 15.8978 12.8381 15.9286C12.7928 15.9365 12.7462 15.9421 12.699 15.9465L12.4118 15.9671C12.29 15.9762 12.1745 16 12.0478 16H5.9466C5.6834 16 5.4321 15.9734 5.1892 15.9335C5.1801 15.9321 5.1717 15.9307 5.1633 15.9293C4.2162 15.7662 3.4301 15.3091 2.8792 14.6196C2.8729 14.6196 2.8729 14.6126 2.8666 14.6063C2.3129 13.9091 2 12.9718 2 11.8714V6.1216C2 3.6534 3.5897 2 5.9466 2H12.0478ZM12.0478 2.9765H5.9466C4.1427 2.9765 2.9772 4.2134 2.9772 6.1216V11.8714C2.9772 12.4069 3.0766 12.885 3.2467 13.2987C3.2684 13.2728 4.6243 11.6194 4.6306 11.6138C5.115 11.0608 6.0243 10.2362 7.2178 10.7353C7.5048 10.8543 7.7568 11.0216 7.9878 11.1686C8.3889 11.4367 8.6248 11.5627 8.8698 11.5417C8.9713 11.5277 9.0665 11.4976 9.1568 11.4416C9.5474 11.2008 10.6513 9.5908 10.7178 9.5033C11.4808 8.5093 12.6568 8.2433 13.6368 8.8313C13.7026 8.8705 13.9712 9.05477 14.2624 9.26232L14.4822 9.42045C14.7007 9.57913 14.9064 9.73377 15.0235 9.833V6.1216C15.0235 4.2134 13.858 2.9765 12.0478 2.9765ZM6.5355 4.79972C7.02387 4.79972 7.46612 5.00509 7.78288 5.33273C8.101 5.64888 8.30042 6.08461 8.30042 6.56019C8.30042 7.50866 7.50682 8.29972 6.55381 8.29972C5.71612 8.29972 5.00187 7.68768 4.8418 6.89526C4.81534 6.77637 4.80042 6.65409 4.80042 6.52776C4.80042 5.57254 5.57639 4.79972 6.5355 4.79972Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.legend:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.00002 3C8.00002 2.44772 8.44773 2 9.00002 2C9.5523 2 10 2.44772 10 3V4L14.691 4C14.8804 4 15.0535 4.107 15.1382 4.27639L15.8882 5.77639C15.9586 5.91716 15.9586 6.08284 15.8882 6.22361L15.1382 7.72361C15.0535 7.893 14.8804 8 14.691 8L10 8V10H12.5C12.7762 10 13 10.2239 13 10.5V13.5C13 13.7761 12.7762 14 12.5 14H10V15.8C10 15.9105 9.91047 16 9.80002 16H8.20002C8.08956 16 8.00002 15.9105 8.00002 15.8V14H4.23106C4.03499 14 3.85701 13.8854 3.77588 13.7069L3.09406 12.2069C3.03431 12.0754 3.03431 11.9246 3.09406 11.7931L3.77588 10.2931C3.85701 10.1146 4.03499 10 4.23106 10H8.00002V8H5.50002C5.22387 8 5.00002 7.77614 5.00002 7.5L5.00002 4.5C5.00002 4.22386 5.22387 4 5.50002 4L8.00002 4V3Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.zoomOut:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.03998 8.79004H10.54"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M8.65 15.3C12.3227 15.3 15.3 12.3227 15.3 8.65C15.3 4.9773 12.3227 2 8.65 2C4.9773 2 2 4.9773 2 8.65C2 12.3227 4.9773 15.3 8.65 15.3Z"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M16 16.0001L14.6 14.6001"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.zoomIn:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.78998 10.54L8.78998 7.04"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M7.03995 8.79004H10.54"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M16 16.0001L14.6 14.6001"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M8.40696 15.3C12.0796 15.3 15.057 12.3227 15.057 8.65C15.057 4.9773 12.0796 2 8.40696 2C4.73426 2 1.75696 4.9773 1.75696 8.65C1.75696 12.3227 4.73426 15.3 8.40696 15.3Z"
                        stroke={colorIcon}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.checkboxOn:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="13"
                        height="13"
                        rx="1.5"
                        fill={colorIcon}
                        stroke={colorIcon}
                    />

                    <path
                        d="M3.5 6.53341L6.125 9.33341L10.5 4.66675"
                        stroke={Color.white}
                        strokeWidth="1.5"
                    />
                </svg>
            )

        case ICONS_NAME.checkboxOff:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="13"
                        height="13"
                        rx="1.5"
                        fill={Color.white}
                        stroke={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.check:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-check"
                >
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            )

        case ICONS_NAME.rangeHandle:
            return (
                <svg
                    width="24"
                    height="28"
                    viewBox="0 0 24 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d_14331_16715)">
                        <path
                            d="M5 7.58032C5 7.22147 5.19229 6.89012 5.50386 6.71208L11.5039 3.28351C11.8113 3.10783 12.1887 3.10783 12.4961 3.28351L18.4961 6.71208C18.8077 6.89012 19 7.22147 19 7.58032V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V7.58032Z"
                            fill="white"
                        />

                        <path
                            d="M5 7.58032C5 7.22147 5.19229 6.89012 5.50386 6.71208L11.5039 3.28351C11.8113 3.10783 12.1887 3.10783 12.4961 3.28351L18.4961 6.71208C18.8077 6.89012 19 7.22147 19 7.58032V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V7.58032Z"
                            stroke="#E4E4E4"
                        />
                    </g>

                    <rect
                        x="8.75"
                        y="10.25"
                        width="0.5"
                        height="7.5"
                        fill="#EEEEEE"
                        stroke="#E4E4E4"
                        strokeWidth="0.5"
                    />

                    <rect
                        x="11.75"
                        y="10.25"
                        width="0.5"
                        height="7.5"
                        fill="#EEEEEE"
                        stroke="#E4E4E4"
                        strokeWidth="0.5"
                    />

                    <rect
                        x="14.75"
                        y="10.25"
                        width="0.5"
                        height="7.5"
                        fill="#EEEEEE"
                        stroke="#E4E4E4"
                        strokeWidth="0.5"
                    />

                    <defs>
                        <filter
                            id="filter0_d_14331_16715"
                            x="0.5"
                            y="0.651733"
                            width="23"
                            height="26.8483"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />

                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />

                            <feOffset dy="2" />

                            <feGaussianBlur stdDeviation="2" />

                            <feComposite in2="hardAlpha" operator="out" />

                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            />

                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_14331_16715"
                            />

                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_14331_16715"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            )

        case ICONS_NAME.rangeHandleHover:
            return (
                <svg
                    width={size || '28'}
                    height={size || '28'}
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d_12692_10047)">
                        <circle cx="14" cy="12" r="9" fill={Color.white} />

                        <circle cx="14" cy="12" r="9" stroke={Color.textDisabled} />
                    </g>

                    <rect
                        x="10.75"
                        y="8.25"
                        width="0.5"
                        height="7.5"
                        fill={Color.lightGrayHover}
                        stroke={Color.textDisabled}
                        strokeWidth="0.5"
                    />

                    <rect
                        x="13.75"
                        y="8.25"
                        width="0.5"
                        height="7.5"
                        fill={Color.lightGrayHover}
                        stroke={Color.textDisabled}
                        strokeWidth="0.5"
                    />

                    <rect
                        x="16.75"
                        y="8.25"
                        width="0.5"
                        height="7.5"
                        fill={Color.lightGrayHover}
                        stroke={Color.textDisabled}
                        strokeWidth="0.5"
                    />

                    <defs>
                        <filter
                            id="filter0_d_12692_10047"
                            x="0.5"
                            y="0.5"
                            width="27"
                            height="27"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />

                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />

                            <feOffset dy="2" />

                            <feGaussianBlur stdDeviation="2" />

                            <feComposite in2="hardAlpha" operator="out" />

                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            />

                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_12692_10047"
                            />

                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_12692_10047"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            )

        case ICONS_NAME.close:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="1.98124"
                        height="17.8178"
                        transform="matrix(0.707345 0.706868 -0.707345 0.706868 14.6069 2.00146)"
                        fill={colorIcon}
                    />

                    <rect
                        width="1.98124"
                        height="17.8178"
                        transform="matrix(-0.707345 0.706868 0.707345 0.706868 3.39307 2.00146)"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.maximize:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 10H4V12.6L6.59851 10.0015L7.99851 11.4015L5.39998 14L8 14V16H4H2V14V10Z"
                        fill={colorIcon}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 4V2H14H16V4V8H14V5.40002L11.4015 7.99854L10.0015 6.59853L12.6 4L10 4Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.shrink:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 2H12V4.59998L14.5985 2.00146L15.9985 3.40147L13.4 6L16 6V8H12H10V6V2Z"
                        fill={colorIcon}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 12V10H6H8V12V16H6V13.4L3.40149 15.9985L2.00149 14.5985L4.60002 12L2 12Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.modalAlert:
            return (
                <svg
                    width={size || '40'}
                    height={size || '40'}
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
                        fill={Color.redDisabled}
                    />

                    <path
                        d="M34.5422 28.1814L20.8196 6.06456C20.6598 5.80655 20.3781 5.6499 20.0749 5.6499C19.7714 5.6499 19.4898 5.80689 19.3299 6.06456L5.57023 28.242C5.40253 28.5123 5.39401 28.8525 5.54905 29.1304C5.7035 29.4083 5.99721 29.5808 6.3149 29.5808H33.8355H33.8393C34.3234 29.5808 34.7156 29.1882 34.7156 28.7044C34.715 28.5082 34.6509 28.3276 34.5422 28.1814Z"
                        fill={Color.red}
                    />

                    <path
                        d="M19.0591 20.4343L18.7746 16.1772C18.7213 15.3475 18.695 14.7519 18.695 14.3907C18.695 13.899 18.8239 13.5153 19.0812 13.2399C19.3389 12.9636 19.6787 12.8262 20.0991 12.8262C20.6088 12.8262 20.9498 13.0024 21.1213 13.3549C21.2928 13.7076 21.379 14.2161 21.379 14.879C21.379 15.2702 21.3582 15.6678 21.3172 16.0698L20.9347 20.4517C20.8934 20.9733 20.8046 21.3731 20.6679 21.652C20.5315 21.9302 20.306 22.0692 19.9923 22.0692C19.6721 22.0692 19.4501 21.935 19.326 21.665C19.2012 21.3958 19.1122 20.9853 19.0591 20.4343ZM20.0457 26.2824C19.6841 26.2824 19.3683 26.1658 19.0992 25.9318C18.8295 25.6981 18.695 25.3707 18.695 24.95C18.695 24.5825 18.8239 24.2698 19.0812 24.0117C19.3389 23.7541 19.6547 23.6252 20.028 23.6252C20.4016 23.6252 20.7193 23.7537 20.9834 24.0117C21.247 24.2694 21.379 24.5824 21.379 24.95C21.379 25.3647 21.2458 25.6903 20.9785 25.9275C20.712 26.1639 20.4012 26.2824 20.0457 26.2824Z"
                        fill={Color.white}
                    />
                </svg>
            )

        case ICONS_NAME.modalPlanogram:
            return (
                <svg
                    width={size || '40'}
                    height={size || '40'}
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.98075 0H35.8654C36.4315 0 36.9744 0.225765 37.3748 0.627628C37.7751 1.02949 38 1.57454 38 2.14286V37.8571C38 38.4255 37.7751 38.9705 37.3748 39.3724C36.9744 39.7742 36.4315 40 35.8654 40H31.5961C31.03 40 30.487 39.7742 30.0867 39.3724C29.6864 38.9705 29.4615 38.4255 29.4615 37.8571V34.2857H3.84613V2.14286C3.84613 1.57454 4.07103 1.02949 4.47134 0.627628C4.87166 0.225765 5.41461 0 5.98075 0Z"
                        fill={Color.greenSmoke}
                    />

                    <path
                        d="M5.98075 0H35.8654C36.4315 0 36.9744 0.225765 37.3748 0.627628C37.7751 1.02949 38 1.57454 38 2.14286V5.71429H3.84613V2.14286C3.84613 1.57454 4.07103 1.02949 4.47134 0.627628C4.87166 0.225765 5.41461 0 5.98075 0Z"
                        fill={Color.primary}
                    />

                    <path
                        d="M12.3846 0H20.9231V5.71429H12.3846V0Z"
                        fill={Color.primaryHover}
                    />

                    <path
                        d="M29.4615 0H35.8654C36.4315 0 36.9745 0.225765 37.3748 0.627628C37.7751 1.02949 38 1.57454 38 2.14286V5.71429H29.4615V0Z"
                        fill={Color.primaryHover}
                    />

                    <path
                        d="M5.98077 2.14282H7.40385V3.57139H5.98077V2.14282Z"
                        fill={Color.white}
                    />

                    <path
                        d="M8.82697 2.14282H10.25V3.57139H8.82697V2.14282Z"
                        fill={Color.white}
                    />

                    <path
                        d="M14.5192 2.14282H18.7885V3.57139H14.5192V2.14282Z"
                        fill={Color.white}
                    />

                    <path
                        d="M23.0577 2.14282H27.3269V3.57139H23.0577V2.14282Z"
                        fill={Color.white}
                    />

                    <path
                        d="M31.5962 2.14282H35.8654V3.57139H31.5962V2.14282Z"
                        fill={Color.white}
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.3846 5.71436H3.84613V11.4286H12.3846V17.1428H20.923V11.4285H12.3846V5.71436ZM29.4617 5.71436H20.9232V11.4286H29.4616V17.1428H38V11.4285H29.4617V5.71436ZM29.4617 17.1431H20.9232V22.8574H29.4616V28.5715H38V22.8572H29.4617V17.1431ZM12.3846 17.143H3.84614V22.8573H12.3846V28.5715H20.923V22.8572H12.3846V17.143ZM29.4617 28.5715H20.9232V34.2858H29.4616V37.8571C29.4616 38.4254 29.6865 38.9704 30.0868 39.3723C30.4871 39.7742 31.0301 39.9999 31.5962 39.9999H35.8654C36.4316 39.9999 36.9745 39.7742 37.3748 39.3723C37.7751 38.9704 38 38.4254 38 37.8571V34.2856H29.4617V28.5715Z"
                        fill={Color.lightGray}
                    />

                    <path
                        d="M20.2115 39.9999H3.13462C2.56848 39.9999 2.02553 39.7741 1.62521 39.3723C1.2249 38.9704 1 38.4254 1 37.857V29.9999C1 29.4316 1.2249 28.8865 1.62521 28.4847C2.02553 28.0828 2.56848 27.857 3.13462 27.857H6.69231L8.11539 26.4285L9.53846 27.857H20.2115C20.7777 27.857 21.3206 28.0828 21.7209 28.4847C22.1213 28.8865 22.3462 29.4316 22.3462 29.9999V37.857C22.3462 38.4254 22.1213 38.9704 21.7209 39.3723C21.3206 39.7741 20.7777 39.9999 20.2115 39.9999Z"
                        fill={Color.yellow}
                    />

                    <path
                        d="M5.26923 30.7144H6.6923V32.1429H5.26923V30.7144Z"
                        fill={Color.white}
                    />

                    <path
                        d="M8.11542 30.7144H19.5V32.1429H8.11542V30.7144Z"
                        fill={Color.white}
                    />

                    <path
                        d="M3.84613 33.5713H19.5V34.9999H3.84613V33.5713Z"
                        fill={Color.white}
                    />

                    <path
                        d="M3.84613 36.4285H16.6538V37.857H3.84613V36.4285Z"
                        fill={Color.white}
                    />
                </svg>
            )

        case ICONS_NAME.filter:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 3H13"
                        stroke={colorIcon}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M3 7H11"
                        stroke={colorIcon}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M5 11H9"
                        stroke={colorIcon}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.email:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.6708 3H2.32917C2.14737 3 2 3.16403 2 3.36638V10.6336C2 10.836 2.14737 11 2.32917 11H11.6708C11.8526 11 12 10.836 12 10.6336V3.36638C12 3.16403 11.8526 3 11.6708 3Z"
                        stroke={colorIcon}
                        strokeMiterlimit="10"
                    />

                    <path
                        d="M2 3L6.3753 6.50024C6.74052 6.79242 7.25948 6.79242 7.6247 6.50024L12 3"
                        stroke={colorIcon}
                        strokeMiterlimit="10"
                    />
                </svg>
            )

        case ICONS_NAME.user:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 12C8.32608 12 9.59785 11.4732 10.5355 10.5355C11.4732 9.59785 12 8.32608 12 7C12 5.67392 11.4732 4.40215 10.5355 3.46447C9.59785 2.52678 8.32608 2 7 2C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7C2 8.32608 2.52678 9.59785 3.46447 10.5355C4.40215 11.4732 5.67392 12 7 12V12Z"
                        stroke={colorIcon}
                    />

                    <path
                        d="M3.42859 10.5091C3.97645 9.63551 5.36859 9.01622 6.9993 9.01622C8.63145 9.01622 10.0236 9.63622 10.5707 10.5091M7.00002 7.89265C7.28142 7.89265 7.56007 7.83722 7.82005 7.72953C8.08004 7.62184 8.31626 7.464 8.51525 7.26502C8.71423 7.06604 8.87207 6.82981 8.97976 6.56983C9.08745 6.30984 9.14287 6.03119 9.14287 5.74979C9.14287 5.46839 9.08745 5.18974 8.97976 4.92975C8.87207 4.66977 8.71423 4.43354 8.51525 4.23456C8.31626 4.03558 8.08004 3.87774 7.82005 3.77005C7.56007 3.66236 7.28142 3.60693 7.00002 3.60693C6.4317 3.60693 5.88665 3.8327 5.48479 4.23456C5.08292 4.63643 4.85716 5.18147 4.85716 5.74979C4.85716 6.31811 5.08292 6.86316 5.48479 7.26502C5.88665 7.66688 6.4317 7.89265 7.00002 7.89265Z"
                        stroke={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.eyeOff:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.1367 5.06728C11.9914 5.83214 12.638 6.64593 12.9822 7.12347C12.9938 7.139 13 7.15785 13 7.17722C13 7.19658 12.9938 7.21543 12.9822 7.23097C12.1947 8.32596 9.82719 11.1785 6.99969 11.1785C6.40459 11.1785 5.82977 11.052 5.28571 10.8421M9.14286 3.7003C8.47516 3.38164 7.75363 3.17847 6.99969 3.17847C4.17469 3.17847 1.80219 6.03347 1.01719 7.12847C1.00603 7.14322 1 7.16122 1 7.17972C1 7.19821 1.00603 7.21621 1.01719 7.23097C1.37478 7.72864 2.06129 8.59205 2.97012 9.38472"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M5.42525 7.46425C5.40852 7.37149 5.39978 7.27595 5.39978 7.17837C5.39978 6.29471 6.11612 5.57837 6.99978 5.57837C7.04945 5.57837 7.09858 5.58063 7.14709 5.58506M8.58307 7.41042C8.48234 8.10377 7.93696 8.65303 7.24552 8.75961"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M2.36074 11.3964C2.16548 11.5917 2.16548 11.9083 2.36074 12.1036C2.556 12.2988 2.87259 12.2988 3.06785 12.1036L2.36074 11.3964ZM12.0678 3.10355C12.2631 2.90829 12.2631 2.59171 12.0678 2.39645C11.8726 2.20118 11.556 2.20118 11.3607 2.39645L12.0678 3.10355ZM3.06785 12.1036L12.0678 3.10355L11.3607 2.39645L2.36074 11.3964L3.06785 12.1036Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.eyeOn:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.9822 7.05632C12.9938 7.03968 13 7.01948 13 6.99873C13 6.97798 12.9938 6.95778 12.9822 6.94114C12.1947 5.77061 9.82469 2.71436 6.99969 2.71436C4.17469 2.71436 1.80219 5.77328 1.01719 6.9465C1.00603 6.96231 1 6.98159 1 7.00141C1 7.02123 1.00603 7.04051 1.01719 7.05632C1.80219 8.22686 4.17219 11.2858 6.99969 11.2858C9.82719 11.2858 12.1947 8.22953 12.9822 7.05632Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M6.99996 8.71397C7.88362 8.71397 8.59996 7.94646 8.59996 6.99969C8.59996 6.05291 7.88362 5.2854 6.99996 5.2854C6.11631 5.2854 5.39996 6.05291 5.39996 6.99969C5.39996 7.94646 6.11631 8.71397 6.99996 8.71397Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.phone:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.48908 8.47331C9.31256 8.36984 9.0956 8.37201 8.91995 8.47636L8.03039 9.00635C7.83126 9.12505 7.58257 9.11114 7.39996 8.96853C7.08431 8.72201 6.57606 8.30723 6.13389 7.86506C5.69172 7.42289 5.27694 6.91463 5.03042 6.59898C4.88781 6.41637 4.8739 6.16768 4.99259 5.96855L5.52259 5.07899C5.62737 4.90334 5.62824 4.68465 5.52476 4.50813L4.21955 2.27858C4.09303 2.06293 3.84173 1.95684 3.59869 2.01641C3.3626 2.0738 3.05608 2.2138 2.73478 2.53553C1.7287 3.54161 1.19436 5.23856 4.97781 9.02201C8.76126 12.8055 10.4578 12.2715 11.4643 11.265C11.7865 10.9429 11.926 10.6359 11.9838 10.3994C12.0425 10.1568 11.9382 9.90722 11.723 9.78113C11.1856 9.46678 10.0265 8.78809 9.48908 8.47331Z"
                        stroke={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.google:
            return (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.18607 9.99987C4.18607 9.35032 4.29631 8.72759 4.49305 8.14349L1.04931 5.56982C0.378142 6.90348 0 8.40622 0 9.99987C0 11.5922 0.377677 13.094 1.04791 14.4267L4.4898 11.8481C4.29491 11.2667 4.18607 10.6462 4.18607 9.99987Z"
                        fill="#FBBC05"
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.2326 4.09095C11.6745 4.09095 12.9768 4.59096 14.0001 5.40915L16.9769 2.50003C15.1629 0.954556 12.8373 0 10.2326 0C6.18889 0 2.71351 2.26321 1.04932 5.57006L4.49306 8.14372C5.28655 5.78643 7.54843 4.09095 10.2326 4.09095Z"
                        fill="#EB4335"
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.2326 15.9092C7.54843 15.9092 5.28655 14.2137 4.49306 11.8564L1.04932 14.4297C2.71351 17.737 6.18889 20.0002 10.2326 20.0002C12.7285 20.0002 15.1113 19.1329 16.8997 17.5079L13.6308 15.0347C12.7085 15.6033 11.5471 15.9092 10.2326 15.9092Z"
                        fill="#34A853"
                    />

                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.9999 10.0003C19.9999 9.40941 19.9069 8.77304 19.7674 8.18213H10.2324V12.0458H15.7208C15.4464 13.3631 14.6994 14.3758 13.6306 15.0349L16.8994 17.5081C18.7781 15.8018 19.9999 13.2599 19.9999 10.0003Z"
                        fill="#4285F4"
                    />
                </svg>
            )

        case ICONS_NAME.sadRobot:
            return (
                <svg
                    width={size || '450'}
                    height={size || '308'}
                    viewBox="0 0 450 308"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M188.31 287.923C188.31 287.923 138.503 287.923 122.177 287.923C105.85 287.923 102.731 291.756 109.61 294.585C116.49 297.414 83.5605 296.045 77.9653 301.064C72.2784 306.084 86.7709 308 102.456 308C118.141 308 215.919 308 228.485 308C241.051 308 237.933 298.874 230.411 297.688C222.89 296.501 242.611 298.144 250.132 295.498C257.653 292.851 252.242 287.923 188.31 287.923Z"
                        fill="#A9BBCB"
                    />

                    <path
                        d="M284.804 304.624C282.878 307.27 276.457 307.909 265.542 307.635C257.287 307.361 248.665 306.722 248.665 302.89C248.665 299.057 269.669 299.513 277.007 300.334C283.336 301.064 285.905 303.072 284.804 304.624Z"
                        fill="#D9E3EA"
                    />

                    <path
                        d="M94.7512 291.847C93.467 293.764 89.0642 294.311 81.3594 294.311C75.5808 294.311 69.5269 294.037 69.3435 291.391C69.16 288.653 83.9277 288.562 89.156 289.018C93.5587 289.383 95.485 290.661 94.7512 291.847Z"
                        fill="#C5D3DE"
                    />

                    <path
                        d="M417.713 285.642H384.968C382.399 285.642 380.29 283.543 380.29 280.987V247.313C380.29 244.757 382.399 242.658 384.968 242.658H417.713C420.281 242.658 422.391 244.757 422.391 247.313V280.987C422.391 283.543 420.281 285.642 417.713 285.642Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M416.154 284.09H384.693C382.216 284.09 380.198 282.082 380.198 279.618V247.13C380.198 244.666 382.216 242.658 384.693 242.658H416.154C418.631 242.658 420.649 244.666 420.649 247.13V279.618C420.649 282.082 418.631 284.09 416.154 284.09Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M400.744 276.881C408.039 276.881 413.953 270.997 413.953 263.739C413.953 256.481 408.039 250.598 400.744 250.598C393.449 250.598 387.536 256.481 387.536 263.739C387.536 270.997 393.449 276.881 400.744 276.881Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M395.516 269.671C395.058 269.671 394.691 269.306 394.691 268.85V258.72C394.691 258.264 395.058 257.899 395.516 257.899C395.975 257.899 396.342 258.264 396.342 258.72V268.85C396.342 269.306 395.975 269.671 395.516 269.671Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M405.055 269.671C404.597 269.671 404.23 269.306 404.23 268.85V258.72C404.23 258.264 404.597 257.899 405.055 257.899C405.514 257.899 405.881 258.264 405.881 258.72V268.85C405.881 269.306 405.514 269.671 405.055 269.671Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M320.761 228.696C320.119 228.696 319.477 228.696 318.835 228.605C304.617 227.601 294.895 222.764 278.568 198.033C272.881 189.454 269.028 180.693 265.268 172.206C258.847 157.696 253.343 145.102 240.869 139.262C221.698 130.318 202.895 145.102 202.711 145.285C201.886 145.924 200.694 145.832 200.051 145.011C199.409 144.19 199.501 143.003 200.327 142.365C201.152 141.726 221.148 125.938 242.428 135.885C256.187 142.273 262.241 156.053 268.661 170.655C272.33 179.051 276.183 187.72 281.686 195.934C297.188 219.296 306.085 223.859 319.11 224.863C328.833 225.593 334.061 219.752 339.106 214.003C340.94 211.995 342.591 210.079 344.517 208.436C351.947 202.139 359.744 200.953 360.111 200.953C361.12 200.771 362.129 201.501 362.22 202.504C362.404 203.508 361.67 204.512 360.661 204.603C360.569 204.603 353.598 205.698 346.994 211.265C345.251 212.725 343.692 214.551 341.949 216.467C336.813 222.308 331.126 228.696 320.761 228.696Z"
                        fill="#839EB3"
                    />

                    <path
                        d="M374.144 194.656L381.849 188.177C382.675 187.538 383.775 187.629 384.417 188.45C384.968 189.18 384.876 190.184 384.142 190.823L376.346 197.668L374.144 194.656Z"
                        fill="#09B38E"
                    />

                    <path
                        d="M369.375 189.181L377.079 182.701C377.905 182.062 379.006 182.154 379.648 182.975C380.198 183.705 380.106 184.709 379.372 185.348L371.576 192.192L369.375 189.181Z"
                        fill="#09B38E"
                    />

                    <path
                        d="M379.556 198.033C379.556 198.033 376.529 201.592 371.851 205.698C367.173 209.714 361.119 208.984 358.368 205.881C358.184 205.698 358.093 205.516 357.909 205.333C355.524 202.048 355.433 197.576 359.01 194.382C362.77 190.914 369.008 185.986 369.008 185.986L376.529 194.656L379.556 198.033Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M379.556 198.032C379.556 198.032 376.529 201.592 371.851 205.698C367.173 209.714 361.12 208.984 358.368 205.881C358.184 205.698 358.093 205.516 357.909 205.333C360.111 205.333 363.871 204.877 367.265 202.595C370.109 200.679 373.778 197.302 376.438 194.656L379.556 198.032Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M239.217 267.937C239.126 267.937 238.942 267.937 238.851 267.937C232.613 267.846 216.378 255.708 212.25 250.05C208.031 244.392 204.27 237.183 209.407 232.529C210.416 231.616 211.884 230.977 213.535 230.703C216.011 230.247 219.038 230.795 221.606 232.437C226.009 235.266 238.392 249.594 241.877 255.708C245.271 261.731 245.18 267.846 239.217 267.937Z"
                        fill="#0EA880"
                    />

                    <path
                        d="M239.218 267.937C240.135 267.39 240.777 266.477 241.327 264.652C242.244 261.458 239.034 255.07 228.486 242.841C222.157 235.449 216.745 232.163 213.535 230.703C216.011 230.247 219.038 230.795 221.606 232.437C226.009 235.266 238.392 249.594 241.878 255.708C245.271 261.731 245.18 267.846 239.218 267.937Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M208.215 236.453C209.132 233.898 214.452 234.354 219.038 238.826C223.624 243.297 230.595 252.149 228.853 255.982C227.11 259.815 220.506 256.712 215.094 251.419C209.682 246.126 206.747 240.559 208.215 236.453Z"
                        fill="#66C5AC"
                    />

                    <path
                        d="M219.772 247.86C219.588 250.78 218.488 252.606 218.488 252.606C218.488 252.606 193.814 264.287 162.903 242.841C131.441 221.03 131.349 193.835 131.349 193.561C147.493 177.864 165.654 195.112 165.654 195.112C165.654 195.112 166.755 204.877 171.708 214.733C174.552 220.391 178.679 226.14 184.55 229.973C199.225 239.555 214.452 236.635 214.452 236.635C214.452 236.635 217.387 237.548 219.13 243.115C219.772 244.757 219.955 246.491 219.772 247.86Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M219.772 247.86C219.588 250.78 218.488 252.606 218.488 252.606C218.488 252.606 193.814 264.287 162.903 242.841C131.441 221.03 131.349 193.835 131.349 193.561C147.493 177.864 165.654 195.112 165.654 195.112C165.654 195.112 166.755 204.877 171.708 214.733C169.232 216.558 166.113 218.475 163.728 219.205C158.683 220.665 153.271 220.665 153.271 220.665C153.271 220.665 168.773 243.753 191.704 247.951C204.087 250.05 213.626 249.138 219.772 247.86Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M185.192 252.515C184.733 252.515 184.275 252.241 184.091 251.693C183.816 251.054 184.183 250.416 184.825 250.142C184.917 250.142 189.87 248.225 191.337 244.21C192.897 240.103 191.613 236.818 191.613 236.818C191.337 236.179 191.704 235.54 192.255 235.267C192.897 234.993 193.539 235.358 193.814 235.905C193.906 236.088 195.373 240.103 193.539 245.031C191.613 250.142 185.834 252.241 185.559 252.332C185.467 252.515 185.284 252.515 185.192 252.515Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M163.911 243.115C163.269 243.115 162.719 242.659 162.719 242.02C162.719 241.381 163.178 240.834 163.82 240.742C163.911 240.742 170.332 240.286 173.542 236.088C176.753 231.89 176.569 227.601 176.569 227.51C176.478 226.871 177.028 226.232 177.67 226.232C178.312 226.141 178.954 226.688 178.954 227.327C178.954 227.51 179.321 232.529 175.469 237.548C171.525 242.567 164.278 243.024 163.911 243.115Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M120.434 225.867C120.067 226.688 119.608 227.509 118.966 228.331C117.774 229.882 116.398 230.795 115.114 231.434C113.279 232.346 111.812 232.529 111.812 232.529C111.812 232.529 98.8785 220.026 87.5964 197.759C76.3143 175.583 75.4888 150.03 75.4888 150.03C76.4977 149.483 77.5067 149.026 78.4239 148.661C81.9095 147.292 85.1198 147.201 87.7798 147.566C91.8157 148.114 94.384 149.848 94.384 149.848C94.384 149.848 95.1178 171.02 102.639 190.093C110.161 209.258 121.168 220.574 121.168 220.574C121.168 220.574 121.626 223.038 120.434 225.867Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M120.434 225.866C116.398 222.307 108.693 214.185 101.263 198.489C92.3661 179.689 88.7888 155.506 87.8716 147.566C91.9075 148.114 94.4757 149.848 94.4757 149.848C94.4757 149.848 95.2095 171.02 102.731 190.093C110.252 209.257 121.259 220.573 121.259 220.573C121.259 220.573 121.626 223.037 120.434 225.866Z"
                        fill="#F5FEFC"
                    />

                    <path
                        d="M115.114 231.434C113.279 232.346 111.812 232.529 111.812 232.529C111.812 232.529 98.8785 220.026 87.5964 197.759C76.3143 175.583 75.4888 150.031 75.4888 150.031C76.4977 149.483 77.5067 149.027 78.4239 148.662C79.066 156.875 82.0929 183.888 94.9343 205.06C103.74 219.479 110.803 227.327 115.114 231.434Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M140.705 244.574C140.705 244.574 135.936 247.404 130.34 246.126C124.745 244.848 122.636 243.023 122.636 243.023C122.636 243.023 120.801 240.285 122.177 238.734C122.269 238.643 122.269 238.643 122.36 238.551C124.103 237 126.488 236.726 126.488 236.726C126.488 236.726 129.79 239.281 132.175 240.103C134.56 240.924 138.779 240.103 140.338 241.107C141.072 241.563 141.164 242.384 141.072 243.114C141.072 243.936 140.705 244.574 140.705 244.574Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M140.705 244.574C140.705 244.574 135.936 247.404 130.34 246.126C124.745 244.848 122.636 243.023 122.636 243.023C122.636 243.023 120.801 240.285 122.177 238.734C123.828 240.285 127.772 243.662 132.358 244.209C136.119 244.666 139.238 243.844 141.072 243.114C141.072 243.936 140.705 244.574 140.705 244.574Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M138.963 242.019C134.193 242.749 130.799 241.472 128.231 240.103C125.663 238.734 124.654 237 124.654 237C124.654 237 124.654 234.901 126.029 233.806C126.763 233.167 127.956 232.893 129.79 233.441C129.79 233.441 133.367 236.544 139.329 234.445C145.292 232.346 144.925 231.068 146.209 230.703C147.126 230.429 148.318 231.798 148.594 233.35C148.777 234.08 148.685 234.81 148.41 235.449C147.401 237.456 143.732 241.198 138.963 242.019Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M138.963 242.02C134.193 242.75 130.799 241.472 128.231 240.103C125.663 238.734 124.654 237 124.654 237C124.654 237 124.654 234.901 126.029 233.806C128.231 235.996 133 239.921 138.229 238.917C143.365 237.913 147.034 234.901 148.685 233.35C148.869 234.08 148.777 234.81 148.502 235.449C147.401 237.457 143.732 241.198 138.963 242.02Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M137.954 235.996C133.367 236.726 130.157 235.449 127.772 234.171C125.296 232.893 124.378 231.251 124.378 231.251C124.378 231.251 124.378 229.243 125.663 228.148C126.396 227.509 127.497 227.235 129.24 227.783C129.24 227.783 132.634 230.703 138.321 228.695C144.007 226.688 143.641 225.501 144.833 225.136C145.658 224.863 146.851 226.231 147.126 227.692C147.31 228.33 147.218 229.061 146.943 229.699C145.934 231.707 142.448 235.266 137.954 235.996Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M137.954 235.996C133.367 236.726 130.157 235.449 127.772 234.171C125.296 232.893 124.378 231.251 124.378 231.251C124.378 231.251 124.378 229.243 125.663 228.148C127.681 230.247 132.267 233.988 137.22 232.985C142.081 231.981 145.567 229.152 147.126 227.692C147.31 228.33 147.218 229.06 146.943 229.699C145.934 231.707 142.448 235.266 137.954 235.996Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M137.312 231.433C133.368 232.711 130.249 232.072 127.956 231.251C125.571 230.429 124.562 229.152 124.562 229.152C124.562 229.152 124.287 227.327 125.388 226.231C125.938 225.593 126.947 225.228 128.598 225.41C128.598 225.41 131.992 227.509 136.853 225.045C141.715 222.49 141.256 221.486 142.265 220.938C142.999 220.573 144.191 221.577 144.65 222.855C144.833 223.402 144.925 224.041 144.741 224.68C144.008 226.505 141.256 230.156 137.312 231.433Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M137.312 231.433C133.368 232.711 130.249 232.072 127.956 231.251C125.571 230.429 124.562 229.152 124.562 229.152C124.562 229.152 124.287 227.327 125.388 226.231C127.497 227.783 131.992 230.521 136.303 228.969C140.614 227.418 143.366 224.406 144.558 222.855C144.741 223.402 144.833 224.041 144.65 224.68C144.008 226.505 141.256 230.156 137.312 231.433Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M134.101 227.053C134.101 227.053 133.826 228.604 133.184 230.703C132.45 233.076 131.35 235.996 129.699 238.278C128.965 239.19 128.231 240.012 127.497 240.651C125.021 242.932 122.727 243.388 122.727 243.388C122.727 243.388 115.665 236.635 113.647 234.354C111.629 232.163 109.978 229.791 109.978 229.791C109.978 229.791 109.427 227.235 109.978 224.498C110.253 223.038 110.803 221.486 111.904 220.3C112.454 219.752 113.096 219.296 113.647 218.931C116.674 217.379 120.159 218.566 120.159 218.566C120.159 218.566 126.947 222.764 129.974 224.406C133.001 226.049 134.101 227.053 134.101 227.053Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M134.102 227.053C134.102 227.053 133.826 228.604 133.184 230.703C131.808 229.973 129.332 228.422 126.03 226.049C121.719 223.038 115.573 219.935 113.647 218.931C116.674 217.379 120.159 218.566 120.159 218.566C120.159 218.566 126.947 222.764 129.974 224.406C133.001 226.049 134.102 227.053 134.102 227.053Z"
                        fill="#F8FBFF"
                    />

                    <path
                        d="M127.497 240.559C125.021 242.749 122.727 243.297 122.727 243.297C122.727 243.297 115.665 236.452 113.647 234.262C111.629 232.072 109.978 229.699 109.978 229.699C109.978 229.699 109.427 227.144 109.978 224.406C112.821 227.6 120.434 235.814 125.754 239.282C126.396 239.829 127.038 240.194 127.497 240.559Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M101.264 217.197C99.888 217.106 99.0625 216.649 98.9708 216.649C98.4204 216.376 98.237 215.646 98.5122 215.098C98.7873 214.55 99.4294 214.277 99.9798 214.55C100.071 214.642 102.64 215.828 106.034 213.638C109.427 211.448 109.978 208.71 109.978 208.619C110.069 207.98 110.62 207.523 111.262 207.706C111.812 207.797 112.271 208.436 112.179 209.075C112.179 209.257 111.537 212.908 107.226 215.737C104.749 217.106 102.731 217.288 101.264 217.197Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M91.4494 198.854C89.5232 198.671 88.239 198.033 88.1473 198.033C87.597 197.759 87.4135 197.029 87.6887 196.481C87.9639 195.934 88.6059 195.66 89.0645 195.934C89.1563 196.025 92.3666 197.576 96.586 195.66C100.714 193.835 101.447 191.188 101.447 191.006C101.631 190.367 102.181 190.002 102.731 190.184C103.282 190.367 103.649 191.006 103.465 191.644C103.465 191.827 102.456 195.477 97.3197 197.85C95.0266 198.854 93.0087 199.036 91.4494 198.854Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M84.4784 178.32C81.8183 178.138 80.4425 177.043 80.3508 176.952C79.8921 176.587 79.8004 175.856 80.1673 175.309C80.5342 174.761 81.1763 174.67 81.7266 175.126C81.8183 175.126 83.8363 176.678 88.3308 175.765C94.0177 174.579 95.577 172.389 95.6687 172.297C96.0356 171.75 96.6777 171.659 97.2281 172.024C97.6867 172.389 97.7784 173.119 97.4115 173.666C97.2281 173.94 95.2101 176.587 88.7894 178.047C87.0467 178.412 85.6708 178.412 84.4784 178.32Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M98.0533 163.08C98.0533 163.08 92.5498 165.909 84.7532 165.818C80.9008 165.727 78.2408 164.997 76.498 164.176C74.6635 163.354 73.838 162.533 73.838 162.533C73.838 162.533 73.9297 160.89 73.6546 155.506C72.7373 138.532 80.4422 136.341 85.487 136.159C86.6794 136.159 87.9636 136.341 89.0643 136.706C92.7332 137.984 95.8519 141.269 97.0443 145.285C98.6036 150.852 98.0533 163.08 98.0533 163.08Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M86.7711 146.654C80.9924 149.757 78.6076 147.749 78.6076 147.749C78.6076 147.749 77.2318 152.403 76.5897 161.62C76.498 162.533 76.498 163.445 76.4062 164.176C74.5717 163.354 73.7462 162.533 73.7462 162.533C73.7462 162.533 73.8379 160.89 73.5628 155.506C72.6455 138.532 80.3504 136.341 85.3952 136.159C86.5876 136.159 87.8718 136.341 88.9725 136.706C90.4401 139.17 92.0911 143.825 86.7711 146.654Z"
                        fill="#0EA880"
                    />

                    <path
                        d="M203.903 175.126C203.628 176.586 203.353 177.955 202.986 179.324C200.784 187.811 196.932 194.656 191.52 199.127C176.019 211.995 154.739 218.839 127.405 201.226C105.574 187.172 85.4867 155.323 78.2404 143.003C76.4059 139.9 75.397 137.984 75.397 137.984C75.397 137.984 87.9632 137.345 107.776 128.31C115.939 124.569 125.387 119.367 135.752 112.249C153.638 99.8374 164.003 88.2475 169.965 79.2128C177.028 68.6267 178.037 61.691 178.037 61.691C178.037 61.691 179.779 64.8851 182.806 71.9121C186.475 80.5817 191.979 95.0007 198.216 116.355C204.912 139.353 206.746 159.703 203.903 175.126Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M182.807 71.9122C180.697 76.1101 177.762 81.0381 173.909 86.4224C166.388 96.6434 155.198 108.416 138.687 119.002C128.506 125.573 119.425 130.318 111.445 133.786C95.1181 140.995 83.836 142.638 78.1491 142.912C76.3146 139.809 75.3057 137.893 75.3057 137.893C75.3057 137.893 87.8719 137.254 107.684 128.219C115.848 124.477 125.295 119.276 135.66 112.157C153.547 99.7462 163.911 88.1563 169.874 79.1216C176.936 68.5356 177.945 61.5999 177.945 61.5999C177.945 61.5999 179.872 64.9764 182.807 71.9122Z"
                        fill="#0EA880"
                    />

                    <path
                        d="M202.986 179.324C200.784 187.811 196.932 194.656 191.52 199.127C176.019 211.995 154.739 218.839 127.405 201.226C105.574 187.173 85.4867 155.323 78.2404 143.003C76.4059 139.9 75.397 137.984 75.397 137.984C75.397 137.984 87.9632 137.345 107.776 128.31C115.572 140.357 132.816 165.27 149.785 179.963C169.506 197.12 191.979 186.99 202.986 179.324Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M111.445 133.877C95.1181 141.087 83.836 142.729 78.1491 143.003C76.3146 139.9 75.3057 137.984 75.3057 137.984C75.3057 137.984 87.8719 137.345 107.684 128.31C108.785 129.953 110.069 131.869 111.445 133.877Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M201.335 166.274C199.042 156.874 195.923 145.011 191.979 132.417C185.65 111.975 178.495 96.187 174.551 89.3426C180.055 81.038 181.064 77.6614 181.064 77.6614C181.064 77.6614 182.44 80.2166 184.824 85.6922C187.668 92.4454 191.979 103.762 196.84 120.462C202.16 138.349 203.628 154.228 201.335 166.274Z"
                        fill="#F5FEFC"
                    />

                    <path
                        d="M182.806 71.9122C180.697 76.1101 177.761 81.0381 173.909 86.4224C172.441 83.5933 171.157 81.1293 169.965 79.1216C177.028 68.5356 178.037 61.5999 178.037 61.5999C178.037 61.5999 179.871 64.9764 182.806 71.9122Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M154.097 173.94C154.097 173.94 145.842 180.146 129.056 187.081C124.378 188.998 119.792 190.64 115.665 192.009C115.298 191.644 114.931 191.279 114.564 190.914C102.823 179.689 92.2749 165.179 85.1204 154.228C84.6618 153.589 84.2949 152.95 83.928 152.403C84.6618 152.22 96.9528 149.117 111.904 142.456C127.405 135.611 131.349 132.508 131.349 132.508L154.097 173.94Z"
                        fill="#DDF5F0"
                    />

                    <path
                        d="M151.529 173.849C151.529 173.849 144.1 179.781 128.323 185.986C123.462 187.903 118.6 189.546 114.473 190.914C102.732 179.69 92.1836 165.179 85.0291 154.228L86.4966 153.863C86.4966 153.863 98.0539 150.943 112.363 144.646C126.672 138.258 130.708 136.159 130.708 136.159L151.529 173.849Z"
                        fill="#09B38E"
                    />

                    <path
                        d="M110.62 177.408C110.344 177.408 109.978 177.317 109.794 177.134L99.7044 168.191L99.0623 170.107C98.7871 170.746 98.1451 171.111 97.503 170.837C96.8609 170.563 96.494 169.925 96.7692 169.286L98.0533 165.635C98.2368 165.27 98.512 164.905 98.8789 164.814C99.2458 164.723 99.7044 164.814 100.071 165.088L108.969 172.936L108.51 169.377C108.418 168.829 108.693 168.282 109.244 168.099L139.604 155.049C140.247 154.776 140.98 155.049 141.256 155.688C141.531 156.327 141.256 157.057 140.613 157.331L111.078 170.016L111.904 175.948C111.995 176.495 111.72 176.952 111.262 177.225C110.986 177.317 110.803 177.408 110.62 177.408Z"
                        fill="white"
                    />

                    <path
                        d="M178.037 61.6911C178.037 61.6911 176.661 71.4558 166.113 85.0535C160.059 92.9018 150.887 102.028 137.128 111.336C114.564 126.668 96.7693 133.147 86.1292 135.976C79.1582 137.801 75.3058 137.984 75.3058 137.984C75.3058 137.984 52.2829 98.9249 56.0436 63.5163C57.0526 54.2991 59.8961 46.6333 64.2071 40.3364C67.3257 35.6822 71.1782 31.8493 75.5809 28.6552C88.3306 19.5293 105.483 16.3352 122.177 18.3429C152.629 22.0846 178.037 61.6911 178.037 61.6911Z"
                        fill="#D4EEFD"
                    />

                    <path
                        d="M178.038 61.6912C178.038 61.6912 177.395 66.0716 173.91 73.0073C172.167 76.4752 169.691 80.5818 166.113 85.1448C160.06 92.9931 150.887 102.119 137.128 111.427C112.821 127.854 94.0179 134.151 83.8365 136.615C78.3331 137.893 75.3062 138.075 75.3062 138.075C75.3062 137.801 75.3979 116.812 109.703 90.164C144.191 63.2426 178.038 61.6912 178.038 61.6912Z"
                        fill="#CAE8F9"
                    />

                    <path
                        d="M173.91 73.0072C172.167 76.4751 169.69 80.5817 166.113 85.1447C160.059 92.993 150.887 102.119 137.128 111.427C112.821 127.854 94.0178 134.151 83.8364 136.615C87.6889 127.854 96.1275 114.895 115.114 100.111C138.412 81.9506 161.435 75.3799 173.91 73.0072Z"
                        fill="#C2E1F3"
                    />

                    <path
                        d="M178.038 61.6911C178.038 61.6911 176.662 71.4558 166.113 85.0534C160.243 75.0149 155.015 68.718 155.015 68.718C155.015 68.718 141.531 80.8555 130.524 72.1859C119.517 63.425 127.773 47.3634 127.773 47.3634C127.773 47.3634 116.674 35.4997 98.6043 31.6668C89.6153 29.7503 81.4518 28.929 75.4897 28.6552C88.2394 19.5293 105.392 16.3352 122.086 18.3429C152.63 22.0846 178.038 61.6911 178.038 61.6911Z"
                        fill="#DBF2FF"
                    />

                    <path
                        d="M86.221 135.976C79.25 137.801 75.3976 137.984 75.3976 137.984C75.3976 137.984 52.3747 98.925 56.1354 63.5164C57.1444 54.2992 59.9879 46.6334 64.2989 40.3365C63.2899 50.8314 62.4644 75.1063 70.9031 101.298C75.1224 114.622 80.8093 126.485 86.221 135.976Z"
                        fill="#EAF7FE"
                    />

                    <path
                        d="M190.971 294.95C190.971 295.497 190.971 296.045 190.879 296.684C190.512 302.068 173.91 303.072 162.353 303.619C150.979 304.167 138.963 300.973 143.09 297.231C143.182 297.14 143.182 297.14 143.274 297.049C146.209 294.585 151.896 291.756 158.225 289.474C161.894 288.105 165.655 287.01 169.415 286.098C174.368 284.911 184.458 282.539 187.76 285.003C188.402 285.459 188.953 286.189 189.411 287.01C190.42 288.927 190.971 291.756 190.971 294.95Z"
                        fill="#0EA880"
                    />

                    <path
                        d="M190.971 294.95C190.971 295.497 190.971 296.045 190.879 296.684C190.512 302.068 173.91 303.072 162.353 303.619C150.979 304.167 138.963 300.973 143.09 297.231C145.567 298.691 150.979 300.425 162.261 299.969C177.67 299.33 187.026 296.775 190.971 294.95Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M189.319 287.01C188.586 287.74 187.393 288.47 186.017 289.2C181.615 291.391 168.223 293.763 160.059 292.395C156.482 291.756 156.757 290.661 158.133 289.474C161.802 288.105 165.563 287.01 169.324 286.098C174.277 284.911 184.366 282.539 187.668 285.003C188.31 285.459 188.861 286.189 189.319 287.01Z"
                        fill="#66C5AC"
                    />

                    <path
                        d="M168.681 243.205C172.35 266.568 185.742 284.455 185.742 284.455C185.742 284.455 184.458 286.28 181.89 287.923C180.789 288.653 179.505 289.2 177.945 289.748C175.561 290.478 172.992 290.478 170.791 290.295C168.131 290.021 166.205 289.474 166.205 289.474C166.205 289.474 143.365 260.18 140.522 226.779C137.678 193.378 155.748 176.586 155.748 176.586C155.748 176.586 155.932 176.495 156.115 176.312C157.949 175.126 166.021 170.746 175.744 176.221C176.478 176.586 177.12 177.043 177.67 177.408C185.1 182.244 186.201 187.172 186.201 187.172C186.201 187.172 181.156 191.553 177.395 198.123C173.634 204.512 165.012 219.843 168.681 243.205Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M168.681 243.206C172.35 266.568 185.742 284.455 185.742 284.455C185.742 284.455 184.458 286.28 181.89 287.923C175.194 278.706 159.142 250.78 159.692 224.224C160.151 199.949 172.809 183.066 177.762 177.408C185.192 182.245 186.292 187.173 186.292 187.173C186.292 187.173 181.248 191.553 177.487 198.124C173.634 204.512 165.012 219.843 168.681 243.206Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M170.699 290.204C168.039 289.931 166.113 289.383 166.113 289.383C166.113 289.383 143.274 260.089 140.43 226.688C137.587 193.287 155.657 176.495 155.657 176.495C155.657 176.495 155.84 176.404 156.023 176.222C152.538 183.34 144.741 201.774 145.475 222.581C146.392 249.32 158.041 269.945 166.205 283.086C167.764 285.733 169.323 288.105 170.699 290.204Z"
                        fill="#F5FEFC"
                    />

                    <path
                        d="M153.272 266.477C152.997 266.477 152.63 266.386 152.446 266.112C151.988 265.655 151.896 264.834 152.355 264.378C152.446 264.287 155.106 261.549 160.426 259.906C165.838 258.263 171.8 260.089 172.075 260.18C172.718 260.362 173.084 261.093 172.901 261.731C172.718 262.37 171.984 262.735 171.342 262.553C171.25 262.553 165.838 260.91 161.16 262.279C156.482 263.739 154.189 266.021 154.189 266.112C154.006 266.386 153.639 266.477 153.272 266.477Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M143.824 237.274C143.365 237.274 142.999 237.091 142.723 236.635C142.356 235.996 142.54 235.266 143.182 234.901C143.365 234.81 148.777 231.707 154.923 231.433C161.16 231.068 166.388 234.627 166.572 234.81C167.122 235.175 167.306 235.996 166.847 236.544C166.48 237.091 165.654 237.274 165.104 236.818C165.012 236.818 160.426 233.623 155.014 233.897C149.419 234.171 144.466 237 144.374 237.091C144.283 237.274 144.008 237.274 143.824 237.274Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M168.956 213.181C168.681 213.181 168.314 213.09 168.131 212.816C168.039 212.725 161.252 206.611 154.464 205.789C147.86 204.968 143.824 207.797 143.824 207.888C143.274 208.253 142.448 208.162 142.081 207.615C141.714 207.067 141.806 206.246 142.356 205.881C142.54 205.698 147.218 202.322 154.831 203.325C162.352 204.329 169.507 210.717 169.874 210.991C170.424 211.448 170.424 212.269 169.965 212.725C169.599 212.999 169.232 213.181 168.956 213.181Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M249.032 187.263C249.032 187.263 247.289 193.195 241.786 196.754C236.282 200.314 233.163 200.679 233.163 200.679C233.163 200.679 229.586 200.131 229.586 197.85C229.586 197.758 229.586 197.667 229.586 197.576C229.77 195.112 231.512 192.921 231.512 192.921C231.512 192.921 236.19 192.1 238.759 190.823C241.327 189.545 244.079 185.438 246.097 184.982C247.106 184.799 247.748 185.256 248.298 185.895C248.848 186.533 249.032 187.263 249.032 187.263Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M249.032 187.264C249.032 187.264 247.289 193.195 241.786 196.755C236.282 200.314 233.163 200.679 233.163 200.679C233.163 200.679 229.586 200.131 229.586 197.85C232.063 197.667 237.933 196.937 242.061 193.652C245.455 191.005 247.381 187.811 248.298 185.803C248.848 186.534 249.032 187.264 249.032 187.264Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M245.638 186.807C242.336 191.279 238.575 193.013 235.456 194.108C232.338 195.203 230.228 194.747 230.228 194.747C230.228 194.747 228.577 193.195 228.852 191.279C228.944 190.184 229.678 188.997 231.604 187.902C231.604 187.902 236.832 187.263 240.134 180.875C243.436 174.487 242.061 173.848 242.886 172.571C243.436 171.658 245.454 171.749 246.83 172.571C247.472 172.936 248.023 173.575 248.206 174.305C249.032 176.586 248.94 182.335 245.638 186.807Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M245.638 186.807C242.336 191.279 238.575 193.013 235.456 194.108C232.338 195.203 230.228 194.747 230.228 194.747C230.228 194.747 228.577 193.195 228.852 191.279C232.246 191.096 239.217 190.184 242.611 185.165C246.005 180.237 246.738 175.035 246.83 172.571C247.472 172.936 248.023 173.575 248.206 174.305C249.032 176.586 248.94 182.336 245.638 186.807Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M239.493 183.978C236.374 188.176 232.797 189.91 229.77 190.914C226.835 191.918 224.817 191.462 224.817 191.462C224.817 191.462 223.258 190.001 223.533 188.176C223.625 187.172 224.358 185.986 226.193 184.982C226.193 184.982 231.146 184.435 234.265 178.32C237.383 172.297 236.099 171.658 236.833 170.381C237.383 169.559 239.218 169.559 240.594 170.381C241.236 170.746 241.694 171.293 241.969 172.023C242.703 174.305 242.611 179.78 239.493 183.978Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M239.493 183.978C236.374 188.176 232.797 189.91 229.77 190.914C226.835 191.918 224.817 191.461 224.817 191.461C224.817 191.461 223.258 190.001 223.533 188.176C226.743 187.993 233.347 187.172 236.649 182.427C239.86 177.772 240.502 172.844 240.685 170.472C241.327 170.837 241.786 171.384 242.061 172.114C242.703 174.305 242.611 179.78 239.493 183.978Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M237.016 192.1C237.108 194.747 236.466 196.937 235.732 198.58C234.723 200.679 233.622 201.774 233.622 201.774C233.622 201.774 210.416 209.896 186.017 189.636C173.451 179.233 163.361 165.635 156.574 154.958C150.153 144.828 146.576 137.254 146.576 137.254C146.576 137.254 144.65 131.322 148.227 126.211C149.327 124.569 150.979 123.017 153.547 121.74C157.858 119.549 161.435 119.367 164.279 120.097C169.048 121.283 171.708 124.842 171.708 124.842C171.708 124.842 175.285 132.691 180.606 142.364C186.843 153.589 195.465 167.278 203.72 173.666C219.038 185.53 231.788 180.967 231.788 180.967C231.788 180.967 233.164 182.336 234.539 184.435C235.548 186.351 236.924 189.089 237.016 192.1Z"
                        fill="#E5F3F0"
                    />

                    <path
                        d="M180.33 142.181C178.404 145.193 174.643 149.665 167.672 152.22C163.178 153.954 159.233 154.593 156.39 154.866C149.969 144.737 146.392 137.162 146.392 137.162C146.392 137.162 143.09 126.85 153.271 121.557C164.737 115.625 171.433 124.66 171.433 124.66C171.433 124.66 175.01 132.599 180.33 142.181Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M235.64 198.489C234.631 200.588 233.53 201.683 233.53 201.683C233.53 201.683 210.324 209.805 185.925 189.545C173.359 179.142 163.27 165.544 156.482 154.867C150.061 144.737 146.484 137.162 146.484 137.162C146.484 137.162 144.558 131.231 148.135 126.12C151.162 132.964 164.095 160.89 180.514 176.951C199.317 195.294 209.499 197.576 227.568 198.306C230.504 198.397 233.255 198.489 235.64 198.489Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M234.264 184.344C229.586 185.712 223.074 186.716 216.286 184.617C203.628 180.693 193.263 172.754 183.082 157.513C174.735 144.92 166.663 126.303 164.095 120.006C168.864 121.192 171.524 124.751 171.524 124.751C171.524 124.751 175.102 132.6 180.422 142.273C186.659 153.498 195.281 167.187 203.536 173.575C218.854 185.439 231.604 180.876 231.604 180.876C231.604 180.876 232.888 182.153 234.264 184.344Z"
                        fill="#F5FEFC"
                    />

                    <path
                        d="M170.699 170.016C168.406 170.016 166.938 169.468 166.847 169.468C166.205 169.194 165.838 168.464 166.113 167.825C166.388 167.186 167.122 166.821 167.764 167.095C167.947 167.186 172.258 168.647 178.037 165.544C183.816 162.35 185.192 156.692 185.192 156.692C185.375 156.053 186.017 155.597 186.659 155.779C187.301 155.962 187.76 156.6 187.576 157.239C187.485 157.513 186.017 163.992 179.138 167.734C175.927 169.559 172.901 170.016 170.699 170.016Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M188.219 190.458C187.485 190.458 186.935 189.91 186.935 189.18C186.935 188.45 187.485 187.902 188.219 187.902C188.31 187.902 193.997 187.811 197.208 183.887C200.51 179.871 199.868 174.213 199.868 174.122C199.776 173.392 200.326 172.845 200.968 172.753C201.61 172.662 202.253 173.21 202.344 173.848C202.344 174.122 203.078 180.602 199.134 185.438C195.19 190.458 188.494 190.458 188.219 190.458Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M208.398 201.135C207.94 201.135 207.389 200.861 207.206 200.314C206.931 199.675 207.297 198.945 207.94 198.671C208.031 198.671 213.168 196.572 214.544 191.005C215.92 185.347 213.993 182.062 213.902 181.97C213.535 181.423 213.718 180.602 214.268 180.237C214.819 179.872 215.644 180.054 216.011 180.602C216.103 180.784 218.671 184.891 216.928 191.553C215.186 198.397 209.04 200.861 208.765 200.952C208.673 201.135 208.582 201.135 208.398 201.135Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M181.064 131.23C181.064 131.23 180.88 132.325 180.238 133.968C178.954 137.071 175.927 142.181 169.048 146.653C158.408 153.498 148.96 150.577 148.96 150.577C148.96 150.577 142.173 141.725 140.797 129.496C139.971 122.469 144.649 116.994 150.703 114.347C155.198 112.431 160.426 112.066 164.645 113.891C174.643 118.363 181.064 131.23 181.064 131.23Z"
                        fill="#0EA880"
                    />

                    <path
                        d="M181.064 131.23C181.064 131.23 180.881 132.325 180.238 133.968C180.238 133.877 180.147 133.877 180.147 133.786C171.616 122.561 164.921 120.279 164.921 120.279C164.921 120.279 162.444 126.12 154.28 122.743C148.594 120.462 149.603 116.446 150.795 114.347C155.289 112.431 160.518 112.066 164.737 113.891C174.643 118.363 181.064 131.23 181.064 131.23Z"
                        fill="#3F8E6A"
                    />

                    <path
                        d="M69.6194 82.9546C67.8767 82.6809 66.2256 83.776 65.8587 85.4186C65.0332 88.8865 63.7491 94.8183 63.1987 99.3813C62.7401 103.214 62.5566 106.408 62.4649 108.598C62.3732 110.15 63.5656 111.61 65.1249 111.884C66.9594 112.158 68.6105 110.88 68.7939 109.055C68.9774 106.226 69.436 101.937 70.4449 97.0086C71.3622 92.3543 72.0043 89.069 72.4629 86.8788C72.7381 85.0536 71.4539 83.3197 69.6194 82.9546Z"
                        fill="#575757"
                    />

                    <path
                        d="M53.751 92.7192C54.2096 90.894 56.1358 89.8901 57.8786 90.7115C60.6303 91.8979 64.6662 93.6318 68.5186 95.0007C72.4628 96.3696 76.1318 97.7384 78.4249 98.651C79.9842 99.1986 80.8097 100.841 80.4428 102.484C79.9842 104.218 78.1497 105.313 76.4069 104.765C73.38 103.944 68.6104 102.393 63.5655 100.294C59.071 98.3773 56.5027 96.9171 54.9434 96.0045C53.9345 95.2744 53.4758 93.9968 53.751 92.7192Z"
                        fill="#575757"
                    />

                    <path
                        d="M109.06 60.6875C106.859 60.3225 104.749 61.7826 104.199 63.9728C103.19 68.5358 101.722 76.2016 101.08 82.2247C100.622 87.2439 100.347 91.3506 100.347 94.1796C100.255 96.2786 101.814 98.0125 103.832 98.2863C106.217 98.6514 108.327 96.9174 108.51 94.5447C108.694 90.8943 109.244 85.3275 110.253 78.9393C111.262 72.825 112.087 68.5358 112.546 65.7068C113.096 63.334 111.445 61.0525 109.06 60.6875Z"
                        fill="#575757"
                    />

                    <path
                        d="M88.6975 73.8288C89.2478 71.456 91.8161 70.1784 94.0175 71.091C97.5947 72.5511 102.823 74.6501 107.868 76.384C113.004 78.118 117.774 79.7606 120.801 80.8557C122.819 81.5858 124.011 83.6848 123.461 85.7837C122.911 88.0652 120.526 89.5254 118.233 88.8865C114.289 87.8827 108.143 86.0575 101.539 83.411C95.6685 81.0383 92.2747 79.2131 90.3485 78.0267C89.0644 77.0228 88.3306 75.3802 88.6975 73.8288Z"
                        fill="#575757"
                    />

                    <path
                        d="M419.548 235.084C419.548 235.084 424.226 236.453 427.619 240.377C431.013 244.392 431.472 250.872 431.472 250.872L450 242.293C450 242.293 440.644 245.852 437.526 239.647C434.407 233.441 444.772 223.585 444.772 223.585C444.772 223.585 433.306 232.894 428.812 231.525C424.317 230.156 423.583 224.589 423.583 224.589L419.548 235.084Z"
                        fill="#FFA78B"
                    />

                    <path
                        d="M402.028 232.985L405.33 233.076L410.467 195.66L398.818 193.469L402.028 232.985Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M410.1 233.167L417.805 198.124L428.904 203.508L412.118 234.08L410.1 233.167Z"
                        fill="#D0E8E3"
                    />

                    <path
                        d="M43.0189 56.307L41.0927 60.5049L0.825684 48.1849L6.23742 32.3971L43.0189 56.307Z"
                        fill="#F68E6D"
                    />

                    <path
                        d="M49.0726 42.4355L45.4953 47.5461L0 13.0501L12.5662 0L49.0726 42.4355Z"
                        fill="#FFA78B"
                    />
                </svg>
            )

        case ICONS_NAME.sidebarImages:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.6096 15.8208C15.5796 15.8494 15.5471 15.8755 15.5147 15.9016C15.4944 15.9179 15.4741 15.9343 15.4544 15.9512C15.3 16.084 15.1424 16.2112 14.9688 16.32L16.948 12.92C16.9216 13.1712 16.8808 13.4112 16.824 13.644C16.8106 13.7022 16.7951 13.7583 16.7794 13.8149L16.776 13.8272C16.712 14.0528 16.6368 14.268 16.5464 14.4736C16.5306 14.5082 16.5139 14.5419 16.4971 14.5756C16.486 14.598 16.4749 14.6205 16.464 14.6432C16.3664 14.8392 16.2608 15.0272 16.1384 15.2016L16.02 15.3552M15.6096 15.8208C15.76 15.6776 15.8928 15.52 16.02 15.3552M15.6096 15.8208L15.2648 15.4587C15.2649 15.4586 15.265 15.4585 15.2651 15.4585M15.6096 15.8208L15.2651 15.4585M16.02 15.3552L15.6242 15.0497M16.02 15.3552L15.624 15.0499L15.6242 15.0497M16.2945 13.6923C16.2947 13.6918 16.2948 13.6913 16.295 13.6907L16.2967 13.6846C16.3131 13.6252 16.3259 13.5789 16.3368 13.5316L16.3382 13.5255L16.3383 13.5255C16.3893 13.3162 16.4265 13.0984 16.4507 12.8677L16.4507 12.8677C16.455 12.8271 16.4625 12.7911 16.4653 12.7775L16.4658 12.775C16.4659 12.7746 16.466 12.7743 16.466 12.774C16.467 12.7579 16.4677 12.7392 16.4684 12.7145C16.4685 12.7104 16.4687 12.7061 16.4688 12.7015C16.4696 12.6732 16.4706 12.636 16.4728 12.5991M16.2945 13.6923L14.224 16.6896C14.1772 16.7074 14.1275 16.7202 14.0775 16.7331C14.0421 16.7423 14.0066 16.7514 13.972 16.7624L13.8241 16.2848C13.8236 16.2849 13.8231 16.2851 13.8226 16.2852C13.8069 16.2901 13.7916 16.2949 13.7765 16.2995C13.5968 16.3553 13.4549 16.3994 13.302 16.4256L13.3001 16.4259C13.2671 16.4317 13.2297 16.4364 13.1862 16.4405L12.8635 16.4637L12.8619 16.4638C12.7956 16.4687 12.7268 16.4772 12.6734 16.4838C12.6593 16.4856 12.6462 16.4872 12.6346 16.4886C12.5712 16.4961 12.5255 16.5 12.4832 16.5H5.5104C5.2434 16.5 4.98413 16.473 4.72585 16.4306L4.72585 16.4306L4.72084 16.4298L4.6983 16.4261C3.72915 16.2589 2.9433 15.796 2.39543 15.1103L2.31988 15.0157C1.80524 14.328 1.5 13.4002 1.5 12.2816V5.7104C1.5 4.40843 1.91764 3.36149 2.60603 2.64342C3.29271 1.92713 4.28483 1.5 5.5104 1.5H12.4832C13.7132 1.5 14.7068 1.92739 15.3939 2.64355C16.0827 3.36151 16.5 4.40832 16.5 5.7104V12.2816C16.5 12.3134 16.4972 12.3482 16.4914 12.4016C16.4906 12.4089 16.4896 12.417 16.4887 12.4257C16.4835 12.472 16.4763 12.5354 16.4728 12.5991M16.2945 13.6923C16.2363 13.8974 16.1692 14.0888 16.0903 14.2687C16.0766 14.2984 16.0666 14.3184 16.0544 14.3429C16.044 14.3636 16.032 14.3876 16.0148 14.4236C15.9264 14.6009 15.8356 14.7614 15.7353 14.9056L15.6242 15.0497M16.2945 13.6923L15.6242 15.0497M16.4728 12.5991C16.4728 12.5987 16.4728 12.5983 16.4729 12.5978L16.972 12.6272L16.4727 12.5998C16.4728 12.5996 16.4728 12.5993 16.4728 12.5991ZM15.2651 15.4585C15.3897 15.3397 15.505 15.2041 15.6242 15.0497M15.2651 15.4585L15.6242 15.0497M1.96236 14.1029L2.27689 14.8679L2.80806 14.2339C2.81817 14.2218 3.01222 13.9854 3.26007 13.6833C3.36952 13.55 3.48947 13.4038 3.6087 13.2585L4.14605 12.604L4.32333 12.3884L4.37291 12.3283L4.38457 12.3143C4.64566 12.0166 4.99063 11.6831 5.39985 11.4838C5.79179 11.2929 6.2416 11.2234 6.7703 11.4445L6.77169 11.4451C7.0279 11.5513 7.25726 11.6977 7.50777 11.8575C7.52837 11.8707 7.54911 11.8839 7.57003 11.8972C7.99931 12.184 8.41306 12.4442 8.8939 12.403L8.90675 12.4019L8.91952 12.4001C9.09211 12.3763 9.26985 12.3224 9.44215 12.2157C9.63025 12.0995 9.84006 11.8721 10.0153 11.6675C10.2076 11.443 10.4168 11.1744 10.6099 10.9174C10.8038 10.6593 10.9852 10.4075 11.1224 10.2149C11.1895 10.1208 11.2462 10.0404 11.2885 9.98047L11.2915 9.97612L11.3432 9.90311C11.3559 9.88514 11.3609 9.87828 11.3614 9.87758C12.0994 8.91791 13.1684 8.71184 14.042 9.23595L14.0433 9.23675C14.0433 9.23674 14.0437 9.23696 14.0445 9.23747L14.045 9.2378L14.0499 9.24082L14.0662 9.25128C14.0798 9.26008 14.0972 9.27151 14.1182 9.28554C14.1602 9.31358 14.214 9.35012 14.2767 9.39326C14.4017 9.47931 14.5591 9.58944 14.7232 9.70638C14.7235 9.70657 14.7237 9.70677 14.724 9.70696L14.9715 9.88503C14.9718 9.88525 14.9721 9.88546 14.9724 9.88568C15.2223 10.0672 15.443 10.2337 15.5607 10.3334L16.384 11.0312V9.952V5.7104C16.384 4.51838 16.0185 3.48818 15.3228 2.75197C14.6243 2.01286 13.6359 1.616 12.4832 1.616H5.5104C4.36084 1.616 3.37423 2.01319 2.67684 2.75225C1.98224 3.48836 1.6168 4.51839 1.6168 5.7104V12.2816C1.6168 12.9562 1.74219 13.5674 1.96236 14.1029ZM7.24954 5.15637L7.24947 5.15644L7.25655 5.16348C7.53231 5.43753 7.70048 5.81034 7.70048 6.21165C7.70048 7.01768 7.01915 7.69968 6.20436 7.69968C5.49157 7.69968 4.87501 7.17446 4.73787 6.49558L4.73796 6.49556L4.73583 6.48599C4.71279 6.38243 4.70048 6.27917 4.70048 6.17459C4.70048 5.36096 5.36153 4.69968 6.18343 4.69968C6.59827 4.69968 6.9762 4.87364 7.24954 5.15637Z"
                        stroke={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.sidebarStores:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.72449 8.4541V11.5971C2.72449 14.7401 3.98449 16.0001 7.12749 16.0001H10.9005C14.0435 16.0001 15.3035 14.7401 15.3035 11.5971V8.4541"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M9.01752 9C10.2985 9 11.2435 7.957 11.1175 6.676L10.6555 2H7.38652L6.91752 6.676C6.79152 7.957 7.73652 9 9.01752 9Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M4.56553 9C5.72053 9 6.76353 8.062 6.87553 6.907L7.02953 5.36L7.36554 2H5.23053C3.39654 2 2.69653 2.7 2.44453 4.52L2.25553 6.445C2.11553 7.852 3.15153 9 4.56553 9Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M9.01752 12.5C7.84852 12.5 7.26752 13.081 7.26752 14.25V16H10.7675V14.25C10.7675 13.081 10.1865 12.5 9.01752 12.5Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    <path
                        d="M13.1915 9C14.6055 9 15.6415 7.852 15.5015 6.445L15.3055 4.52C15.0535 2.7 14.3535 2 12.5195 2H10.3845L10.8745 6.907C10.9935 8.062 12.0365 9 13.1915 9Z"
                        stroke={colorIcon}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.sidebarProjects:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g stroke={colorIcon} clipPath="url(#a)">
                        <path strokeLinecap="round" d="M13.8 7.4h-4" />

                        <path d="M7.4 1.8h5.2c.372 0 .557 0 .713.02a2.4 2.4 0 0 1 2.066 2.067c.021.156.021.342.021.713" />

                        <path d="M1 4.96c0-.706 0-1.06.055-1.353a3.2 3.2 0 0 1 2.552-2.552C3.9 1 4.254 1 4.96 1c.31 0 .464 0 .612.014a3.2 3.2 0 0 1 1.745.722c.115.096.224.205.443.424l.44.44c.653.653.979.979 1.37 1.196.214.12.442.214.678.281.43.123.892.123 1.815.123h.299c2.106 0 3.159 0 3.843.616.063.056.123.116.18.18C17 5.678 17 6.731 17 8.837V10.6c0 3.017 0 4.526-.937 5.463C15.126 17 13.617 17 10.6 17H7.4c-3.017 0-4.525 0-5.463-.937C1 15.126 1 13.617 1 10.6V4.96Z" />
                    </g>

                    <defs>
                        <clipPath id="a">
                            <path fill="#fff" d="M0 0h18v18H0z" />
                        </clipPath>
                    </defs>
                </svg>
            )

        case ICONS_NAME.sidebarPegs:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="1.5"
                        y="1.5"
                        width="15"
                        height="15"
                        rx="3.5"
                        stroke={colorIcon}
                        strokeLinejoin="round"
                    />

                    <rect x="4.5" y="4" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="8.5" y="4" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="12.5" y="4" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="4.5" y="8" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="8.5" y="8" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="12.5" y="8" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="4.5" y="12" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="8.5" y="12" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect
                        x="12.5"
                        y="12"
                        width="1"
                        height="2"
                        rx="0.5"
                        fill={colorIcon}
                    />

                    <rect x="6.5" y="6" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="6.5" y="10" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect x="10.5" y="6" width="1" height="2" rx="0.5" fill={colorIcon} />

                    <rect
                        x="10.5"
                        y="10"
                        width="1"
                        height="2"
                        rx="0.5"
                        fill={colorIcon}
                    />
                </svg>
            )
        case ICONS_NAME.editNote:
            return (
                <svg
                    width={size || '18'}
                    height={size || '18'}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M12.2143 2.84766H5.7857C3.85713 2.84766 2.57141 4.13337 2.57141 6.06194V9.91909C2.57141 11.8477 3.85713 13.1334 5.7857 13.1334H8.35713L11.2178 15.0362C11.6421 15.3191 12.2143 15.0169 12.2143 14.5027V13.1334C14.1428 13.1334 15.4286 11.8477 15.4286 9.91909V6.06194C15.4286 4.13337 14.1428 2.84766 12.2143 2.84766ZM11.25 8.51766H6.74998C6.48641 8.51766 6.26784 8.29909 6.26784 8.03552C6.26784 7.77195 6.48641 7.55337 6.74998 7.55337H11.25C11.5136 7.55337 11.7321 7.77195 11.7321 8.03552C11.7321 8.29909 11.5136 8.51766 11.25 8.51766Z" />
                </svg>
            )

        case ICONS_NAME.downLoad:
            return (
                <svg
                    width={size || 18}
                    height={size || 18}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM12.177 9.927L9.477 12.627C9.342 12.762 9.171 12.825 9 12.825C8.829 12.825 8.658 12.762 8.523 12.627L5.823 9.927C5.562 9.666 5.562 9.234 5.823 8.973C6.084 8.712 6.516 8.712 6.777 8.973L8.325 10.521V5.85C8.325 5.481 8.631 5.175 9 5.175C9.369 5.175 9.675 5.481 9.675 5.85V10.521L11.223 8.973C11.484 8.712 11.916 8.712 12.177 8.973C12.438 9.234 12.438 9.666 12.177 9.927Z"
                        fill={colorIcon}
                    />
                </svg>
            )
        case ICONS_NAME.emptyData:
            return (
                <svg
                    width="50"
                    height="39"
                    viewBox="0 0 50 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.79626 4C1.79626 1.79086 3.58713 0 5.79626 0H21.5464C23.0614 0 24.4465 0.856009 25.1241 2.21115L26.0611 4.08515C26.7386 5.44029 28.1237 6.2963 29.6388 6.2963H40.8812C43.2526 6.2963 45.1033 8.34762 44.8601 10.7065L42.3515 35.0398C42.1413 37.0793 40.4229 38.6296 38.3726 38.6296H5.79626C3.58713 38.6296 1.79626 36.8388 1.79626 34.6296L1.79626 4Z"
                        fill="#E29C33"
                    />

                    <path
                        d="M8.45753 13.1003C9.0022 11.4603 10.5384 10.3555 12.2664 10.3611L44.5087 10.4643C47.1838 10.4728 49.0968 13.0542 48.3265 15.6161L42.2824 35.7166C41.774 37.4073 40.2173 38.5648 38.4518 38.5648H5.54338C2.81497 38.5648 0.887276 35.8933 1.74727 33.304L8.45753 13.1003Z"
                        fill="#FFAE35"
                    />

                    <rect x="24" y="18" width="2" height="11" rx="1" fill="white" />

                    <rect x="24" y="30" width="2" height="2" rx="1" fill="white" />
                </svg>
            )
        case ICONS_NAME.dot:
            return (
                <svg
                    width={size || 10}
                    height={size || 2}
                    viewBox="0 0 10 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="2" height="2" rx="1" fill={colorIcon} />

                    <rect x="4" width="2" height="2" rx="1" fill={colorIcon} />

                    <rect x="8" width="2" height="2" rx="1" fill={colorIcon} />
                </svg>
            )

        case ICONS_NAME.edit:
            return (
                <svg
                    width={size || 10}
                    height={size || 10}
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.44962 7.5945L8.81581 3.31197C9.11855 3.01504 9.12652 2.54144 8.83363 2.25415L7.06586 0.520259C6.77297 0.232977 6.29012 0.240803 5.98738 0.537738L1.58309 4.85764C1.43294 5.00491 1.34896 5.20418 1.35074 5.40892L1.36564 7.11718C1.36916 7.51983 1.69749 7.83685 2.10822 7.83415L3.89919 7.82241C4.104 7.82106 4.30238 7.73893 4.44962 7.5945ZM1.52869 9.01659H8.46203C8.75658 9.01659 8.99536 9.23676 8.99536 9.50835C8.99536 9.77994 8.75658 10.0001 8.46203 10.0001H1.52869C1.23414 10.0001 0.995361 9.77994 0.995361 9.50835C0.995361 9.23676 1.23414 9.01659 1.52869 9.01659Z"
                        fill={colorIcon}
                    />
                </svg>
            )

        case ICONS_NAME.photo:
            return (
                <svg
                    width={size || 14}
                    height={size || 14}
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.0002 3.59241C5.456 3.59241 4.2002 4.84934 4.2002 6.39493C4.2002 7.94121 5.456 9.19744 7.0002 9.19744C8.5444 9.19744 9.8002 7.94121 9.8002 6.39493C9.8002 4.85004 8.5444 3.59241 7.0002 3.59241Z"
                        fill="white"
                    />

                    <path
                        d="M12.6 1.55894H11.249C10.9187 1.55894 10.6034 1.44216 10.3552 1.23626C10.1471 1.0637 9.98905 0.83817 9.8 0.645014C9.61095 0.451857 9.44285 0.218903 9.19075 0.121471C8.96819 0.0354585 8.7009 0.0096584 8.52861 0.0025203C8.41022 -0.00238473 8.29174 0.000862051 8.17324 0.000862051H5.82676C5.70826 0.000862051 5.58978 -0.00238314 5.47139 0.0025051C5.29872 0.00963428 5.03064 0.0354676 4.8078 0.121764C4.55688 0.218932 4.38948 0.450718 4.20127 0.643014C4.01138 0.837031 3.85276 1.06377 3.64363 1.23688C3.3956 1.44219 3.08079 1.55824 2.751 1.55824H1.4C0.6265 1.55824 0 2.18601 0 2.9595L9.91821e-05 10.5987C9.91821e-05 11.3722 0.626599 12 1.4001 12H12.6001C13.3729 12 14.0001 11.3722 14.0001 10.5987L14 2.9595C14 2.18671 13.3728 1.55894 12.6 1.55894ZM7.0001 10.5987C4.6838 10.5987 2.8001 8.71335 2.8001 6.39496C2.8001 4.07728 4.6837 2.25887 7 2.25887C9.3163 2.25887 11.2001 4.07728 11.2001 6.39496C11.2001 8.71405 9.3164 10.5987 7.0001 10.5987Z"
                        fill="white"
                    />
                </svg>
            )

        case ICONS_NAME.add:
            return (
                <svg
                    width={size || '14'}
                    height={size || '14'}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="6" y="2" width="2" height="10" fill={colorIcon} />

                    <rect x="2" y="6" width="10" height="2" fill={colorIcon} />
                </svg>
            )

        case ICONS_NAME.infoSolid:
            return (
                <svg
                    stroke={colorIcon}
                    fill={colorIcon}
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    width={size || '14'}
                    height={size || '14'}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path>
                </svg>
            )

        case ICONS_NAME.comment:
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM18 14H6V12H18V14ZM18 11H6V9H18V11ZM18 8H6V6H18V8Z"
                        fill={color || Color.primary}
                        fillOpacity="0.87"
                    />
                </svg>
            )

        case ICONS_NAME.calendar:
            return (
                <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16.2967 3.08934V6.6536M4.71289 10.2179H20.7521M9.16822 3.33624V6.9005M6.49502 4.87147H18.9699C19.9542 4.87147 20.7521 5.66936 20.7521 6.6536V19.1285C20.7521 20.1128 19.9542 20.9107 18.9699 20.9107H6.49502C5.51078 20.9107 4.71289 20.1128 4.71289 19.1285V6.6536C4.71289 5.66936 5.51078 4.87147 6.49502 4.87147Z"
                        stroke="#828B89"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        case ICONS_NAME.refresh:
            return (
                <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.4883 12C21.4883 9.61305 20.5401 7.32387 18.8522 5.63604C17.1644 3.94821 14.8752 3 12.4883 3C9.97223 3.00947 7.55725 3.99122 5.74828 5.74L3.48828 8M3.48828 8H5.98828M3.48828 8V5.5M3.48828 12C3.48828 14.3869 4.43649 16.6761 6.12432 18.364C7.81215 20.0518 10.1013 21 12.4883 21C15.0043 20.9905 17.4193 20.0088 19.2283 18.26L21.4883 16M21.4883 16H18.9883M21.4883 16V18.5"
                        stroke={color || '#828B89'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )

        default:
            return null
    }
}

export { ICONS_NAME, IconV2 }
